
	import { fabric } from "fabric";
	import {renderGrid, rotateCanvasAndElements, removeGrid, redrawGrid, editMode, viewMode, renderBorder, redrawobjectborder, adjustobjectborder, addText, setObjectBG, checkifrotate, getStrokeWidth, rotatePath} from './CanvasTool'
	import { buildObjectProperty } from './Common'
	const polylabel = require("polylabel");
	const geometric = require("geometric");
	var PolyBool = require('polybooljs');
	const { Point2D, Intersection  } = require("geometric");
	

	// import { Point2D,PolyBool, Intersection  } from "geometric";
	const  turf = require("@turf/turf");

    export var canvasApp ={};
	
	// export var helperCanvas = null;


	var G_SHOW_TIMEZONE = "EST";
	var G_SHOW_ESHOW_FORMAT_URL = "/eshow_programming/programming/testing";
	var G_INCLUDE_PATH = "live";
	var WEB_SERVER = "s2";
	var GRID_SIZE = "10";
	var XMAP_PATH = "H:\eshowtemp";
	var G_GROUP = "D93D4BD5-01D4-4626-BECB-51463D8FF77D";
	var SERVER_NAME = "WEB002";
	var HEIGHTRESIZE = "2";
	var SLABELBOOTHNO = "Booth";
	var BBACKGROUNDIMAGEFOUND = "false";
	var G_DEV_SERVER = "https://s2.goeshow.com";
	var G_SHOW_WINDOW = "yes";
	var MAP_DATA_PATH = "";
	var G_ASSOCIATION = "84CA2444-F4C0-44B0-B14F-0E45B8ED361F";
	var G_ADMIN_SHOW = "B221B39A-3BEB-4ABC-A6A3-53E4A2A24E30";
	var G_USER_NAME = "test";
	var G_NULL = "FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF";
	var G_ONSITE_GROVER = "http://192.168.100.24";
	var G_CRM_DETAIL = "yes";
	var NVERSION = "09182022";
	var G_FORM_WIDTH = "560";
	var XPARAM_STR = "";
	var G_USER = "0106649E-DEE1-4685-AC03-3368AA40C3E4";
	var G_GROVER2 = "http://192.168.100.43";
	var G_REMOTE_URL = "http://grover.goeshow.com/justin/remote_map.cfm";
	var IEDITCANVASHEIGHT = "300";
	var G_SHOW_DIR = "//es2_nas/share.production/h_drive\docs\eshow_programming\programming\testing";
	var G_DRIVE = "h:";
	var G_WEBSERVICES_SERVER = "https://s2.goeshow.com";
	var G_HOME_SERVER = "https://www.goeshow.com";
	var G_SHOW_NAME = "eShow Programming Test Show";
	var G_HOME_GROVER = "http://192.168.100.41";
	var G_ONSITE_SERVER = "http://dev.goeshow.com";
	var XCACHE_TIME = "1";
	var G_SUR_DETAIL = "yes";
	var G_REMOTE_IP = "172.16.11.50";
	var G_ZEUS = "http://zeus.eshow2000.com:2280";
	var G_SHOW_SHORTNAME = "PROG2012";
	var XPAGE_PATH = "exhibitor/space_management.cfm";
	var G_DATASOURCE = "eshow_sql002";
	var SMODE = "exhibitor";
	var G_TPAGE = "TMP0106649EDEE14685AC033368AA40C3E4102255.cfm?pg=";
	var MULTIMAP = "true";
	var CANVASWIDTH = "335.00000000";
	var LAYER_NUMBERS = "1|2|3|4|5|6|7|8|9";
	var WIDTHRESIZE = "2";
	var OTHERBOOTHS = "669570              ,4056                ,4055                ,C31                 ,4054                ,4053                ,4059                ,4058                ,4057                ,458                 ,457                 ,218                 ,217                 ,459                 ,219                 ,461                 ,460                 ,463                 ,220                 ,223                 ,225                 ,224                 ,4052                ,4051                ,4050                ,4067                ,4066                ,4065                ,770                 ,4064                ,4069                ,4068                ,253                 ,495                 ,256                 ,255                 ,258                 ,257                 ,499                 ,4063                ,4062                ,4061                ,4060                ,4078                ,4077                ,4076                ,4075                ,4079                ,247                 ,489                 ,488                 ,4070                ,4074                ,4073                ,4072                ,4071                ,IAC                 ,2064                ,3154                ,4001                ,2065                ,3153                ,2062                ,3152                ,6699468             ,2063                ,3151                ,2068                ,3158                ,4005                ,2069                ,3157                ,4004                ,2066                ,3156                ,4003                ,2067                ,3155                ,4002                ,425                 ,4008                ,424                 ,4007                ,427                 ,466                 ,3159                ,426                 ,429                 ,428                 ,430                 ,432                 ,431                 ,434                 ,433                 ,2060                ,3150                ,2061                ,2075                ,3165                ,2076                ,3164                ,2073                ,3163                ,3162                ,2079                ,3169                ,3168                ,2077                ,3167                ,E30                 ,2078                ,3166                ,3072DD              ,IFP-9               ,418                 ,417                 ,419                 ,421                 ,420                 ,423                 ,422                 ,2071                ,3161                ,2072                ,3160                ,2070                ,2086                ,3176                ,C7                  ,2087                ,3175                ,C20                 ,C8                  ,2084                ,3174                ,C5                  ,2085                ,3173                ,C6                  ,C23                 ,2088                ,C9                  ,2089                ,C22                 ,205                 ,446                 ,207                 ,209                 ,C3                  ,208                 ,C4                  ,C1                  ,C2                  ,210                 ,6699466             ,Ex. Lounge B        ,Ex. Lounge A        ,Ex. Lounge C        ,2082                ,3172                ,2083                ,3171                ,2080                ,3170                ,2081                ,2097                ,4034                ,2098                ,4033                ,2095                ,4032                ,2096                ,4031                ,4038                ,43B                 ,C12                 ,4037                ,43A                 ,C13                 ,2099                ,4036                ,43D                 ,C10                 ,4035                ,43C                 ,C11                 ,436                 ,435                 ,438                 ,4039                ,437                 ,439                 ,441                 ,440                 ,443                 ,442                 ,445                 ,444                 ,C16                 ,2090                ,43E                 ,C17                 ,C14                 ,C15                 ,2093                ,4030                ,EAA 2               ,2094                ,EAA 1               ,2091                ,C18                 ,EAA 4               ,2092                ,C19                 ,EAA 3               ,Forum Seating       ,SPB1                ,SPB2                ,SPB5                ,SPB6                ,SPB3                ,SPB4                ,SPB7                ,SPB8                ,4035AA              ,4035AB              ,117                 ,4089                ,4088                ,4087                ,4086                ,274                 ,273                 ,276                 ,275                 ,277                 ,4081                ,4080                ,270                 ,4085                ,4084                ,272                 ,271                 ,4082                ,4099                ,4098                ,4097                ,259                 ,262                 ,265                 ,269                 ,4091                ,4090                ,4096                ,4095                ,6699373             ,6699374             ,6699380             ,669569              ,669571              ,6696245             ,669573              ,6699402             ,6699406             ,6699405             ,6699401             ,TBD                 ,TBD                 ,669569              ,TBD                 ,669569              ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,TBD                 ,1110                ,1115                ,1116                ,1113                ,801                 ,1114                ,1119                ,803                 ,802                 ,1117                ,805                 ,1118                ,804                 ,71                  ,72                  ,1122                ,1123                ,1120                ,1121                ,1126                ,1127                ,1124                ,1125                ,1128                ,1129                ,68                  ,69                  ,62                  ,63                  ,60                  ,61                  ,67                  ,9                   ,64                  ,901A                ,15                  ,16                  ,19                  ,17                  ,18                  ,262A                ,818A                ,39                  ,833                 ,65                  ,93                  ,22                  ,23                  ,20                  ,21                  ,2020                ,3110                ,2021                ,2024                ,3114                ,3113                ,2022                ,3112                ,2023                ,3111                ,2028                ,3118                ,623                 ,2029                ,3117                ,622                 ,2026                ,3116                ,625                 ,2027                ,3115                ,624                 ,627                 ,626                 ,629                 ,3119                ,628                 ,630                 ,632                 ,631                 ,2031                ,2032                ,3120                ,619                 ,2030                ,2035                ,3125                ,2036                ,3124                ,2033                ,3123                ,2034                ,3122                ,2039                ,3121C               ,3129                ,612                 ,3121D               ,3128                ,611                 ,2037                ,3127                ,614                 ,2038                ,3126                ,613                 ,616                 ,615                 ,618                 ,617                 ,3121A               ,621                 ,3121B               ,620                 ,2042                ,3132                ,2043                ,3131                ,2040                ,3130                ,2041                ,2046                ,3136                ,E21                 ,2047                ,3135                ,E22                 ,3134                ,2045                ,3133                ,E20                 ,403                 ,645                 ,WV7                 ,3139                ,402                 ,644                 ,WV8                 ,2048                ,3138                ,405                 ,647                 ,WV5                 ,2049                ,3137                ,404                 ,646                 ,WV6                 ,407                 ,649                 ,406                 ,648                 ,WV9                 ,650                 ,E25                 ,E26                 ,E23                 ,E24                 ,E29                 ,E27                 ,E28                 ,2053                ,3143                ,2054                ,3142                ,2051                ,3141                ,2052                ,3140                ,2057                ,3147                ,E10                 ,2058                ,3146                ,E11                 ,2055                ,3145                ,2056                ,3144                ,634                 ,633                 ,2059                ,3149                ,636                 ,3148                ,635                 ,638                 ,637                 ,639                 ,135                 ,3104                ,2019                ,3109                ,3108                ,466B                ,3077                ,3076                ,3075                ,3074                ,3079                ,3078                ,348                 ,347                 ,EXL                 ,349                 ,351                 ,350                 ,353                 ,352                 ,355                 ,354                 ,357                 ,356                 ,3073                ,3072                ,3071                ,3070                ,3088                ,3032                ,3087                ,3086                ,3085                ,3089                ,337                 ,336                 ,338                 ,3080                ,3084                ,3083                ,3082                ,3081                ,3099                ,3098                ,3097                ,3096                ,128                 ,369                 ,129                 ,373                 ,372                 ,375                 ,374                 ,377                 ,134                 ,376                 ,379                 ,378                 ,3091                ,3090                ,3095                ,3094                ,3093                ,371                 ,3092                ,370                 ,359                 ,358                 ,362                 ,361                 ,364                 ,363                 ,124                 ,366                 ,365                 ,368                 ,367                 ,360                 ,1096                ,3033                ,1097                ,1094                ,3031                ,1095                ,3030                ,3036                ,1098                ,3035                ,1099                ,3034                ,304                 ,788                 ,787                 ,3039                ,306                 ,3038                ,305                 ,308                 ,307                 ,309                 ,791                 ,790                 ,793                 ,792                 ,311                 ,795                 ,310                 ,794                 ,313                 ,312                 ,796                 ,1092                ,1093                ,1090                ,1091                ,3044                ,3043                ,3072D               ,3042                ,3072C               ,3041                ,3072B               ,3048                ,3072A               ,3047                ,3046                ,3045                ,777                 ,776                 ,779                 ,3049                ,778                 ,780                 ,782                 ,781                 ,300                 ,784                 ,783                 ,786                 ,301                 ,785                 ,3040                ,3055                ,3054                ,3053                ,3052                ,3059                ,3058                ,3057                ,3056                ,329                 ,331                 ,330                 ,333                 ,332                 ,335                 ,334                 ,3050                ,3066                ,3065                ,3064                ,3063                ,3069                ,3068                ,3067                ,315                 ,799                 ,314                 ,798                 ,317                 ,316                 ,319                 ,318                 ,IFP-8               ,320                 ,Chapters            ,322                 ,321                 ,IFP-1               ,IFP-2               ,IFP-3               ,3062                ,IFP-4               ,3061                ,IFP-5               ,3060                ,IFP-7               ,945A                ,190                 ,193                 ,195                 ,194                 ,189                 ,183                 ,NASA                ,2118A               ,Food 1              ,260A                ,260B                ,Forum Stage         ,395                 ,EAA Visa 6          ,397                 ,399                 ,398                 ,EAA Visa 1          ,EAA Visa 3          ,EAA Visa 2          ,393                 ,EAA Visa 5          ,EAA Visa 4          ,384                 ,383                 ,386                 ,385                 ,387                 ,380                 ,140                 ,382                 ,381                 ,175                 ,174                 ,177                 ,176                 ,178                 ,171                 ,170                 ,166                 ,168                 ,167                 ,169                 ,195A                ,162                 ,907                 ,908                 ,905                 ,906                 ,909                 ,900                 ,903                 ,904                 ,901                 ,902                 ,496A                ,929                 ,927                 ,928                 ,712                 ,921                 ,922                 ,920                 ,925                 ,926                 ,923                 ,924                 ,918                 ,827                 ,2025                ,6699462             ,1062                ,2151                ,1067                ,2156                ,3004                ,1068                ,2157                ,3003                ,1065                ,2154                ,3002                ,1066                ,2155                ,3001                ,3008                ,733                 ,3007                ,732                 ,1069                ,2158                ,3006                ,735                 ,2159                ,3005                ,734                 ,737                 ,736                 ,739                 ,3009                ,738                 ,IFP-4A              ,740                 ,500                 ,742                 ,741                 ,1060                ,346                 ,1074                ,3011                ,4100                ,1075                ,3010                ,1072                ,2161                ,1073                ,2162                ,1078                ,3015                ,4104                ,1079                ,3014                ,4103                ,1076                ,3013                ,4102                ,1077                ,3012                ,4101                ,3019                ,3130A               ,4108                ,766                 ,3018                ,3130B               ,4107                ,765                 ,3017                ,4106                ,768                 ,3016                ,4105                ,767                 ,769                 ,4109                ,773                 ,772                 ,775                 ,774                 ,1070                ,1071                ,2160                ,1085                ,3022                ,4111                ,78                  ,1086                ,3021                ,4110                ,1083                ,3020                ,1084                ,1089                ,3026                ,4115                ,3025                ,4114                ,1087                ,3024                ,4113                ,1088                ,3023                ,4112                ,755                 ,3029                ,754                 ,757                 ,3027                ,756                 ,759                 ,758                 ,760                 ,IFP-1A              ,762                 ,761                 ,764                 ,763                 ,1081                ,1082                ,1080                ,708                 ,IFP-13              ,707                 ,IFP-14              ,949                 ,IFP-11              ,709                 ,IFP-12              ,1012                ,IFP-17              ,1013                ,2102                ,IFP-18              ,1010                ,IFP-15              ,2100                ,IFP-16              ,1016                ,2105                ,700                 ,943                 ,1017                ,2106                ,944                 ,1014                ,2103                ,702                 ,941                 ,IFP-19              ,1015                ,2104                ,701                 ,942                 ,2109                ,704                 ,947                 ,703                 ,948                 ,1018                ,2107                ,706                 ,945                 ,1019                ,2108                ,705                 ,946                 ,475A                ,IFP-10              ,1020                ,938                 ,939                 ,2112                ,2113                ,1021                ,2110                ,2111                ,2116                ,932                 ,2117                ,933                 ,2114                ,930                 ,2115                ,931                 ,936                 ,937                 ,2118                ,934                 ,2119                ,935                 ,940                 ,1030                ,1031                ,2120                ,729                 ,1034                ,2123                ,1035                ,2124                ,1032                ,2121                ,1033                ,2122                ,1038                ,2127                ,722                 ,1039                ,721                 ,1036                ,2125                ,724                 ,1037                ,2126                ,723                 ,726                 ,725                 ,2129                ,728                 ,727                 ,731                 ,730                 ,Forums              ,1041                ,2130                ,719                 ,1042                ,2131                ,718                 ,1040                ,1045                ,2134                ,1046                ,2135                ,1043                ,2132                ,1044                ,2133                ,1049                ,2138                ,711                 ,2139                ,710                 ,1047                ,2136                ,713                 ,1048                ,2137                ,715                 ,714                 ,717                 ,716                 ,720                 ,38                  ,600A                ,1000                ,6696243             ,4045                ,E9                  ,4044                ,4043                ,E7                  ,4042                ,E8                  ,4049                ,4048                ,4047                ,4046                ,227                 ,469                 ,E1                  ,226                 ,E2                  ,229                 ,228                 ,E5                  ,E6                  ,6699467             ,E3                  ,E4                  ,471                 ,474                 ,473                 ,476                 ,475                 ,235                 ,477                 ,4041                ,4040                ,470                 ,261                 ,4094                ,4093                ,296                 ,298                 ,297                 ,299                 ,Merch 4             ,Merch 5             ,Merch 6             ,Merch 1             ,Merch 2             ,285                 ,284                 ,287                 ,286                 ,289                 ,288                 ,83                  ,283                 ,292A                ,51                  ,52                  ,55                  ,56                  ,53                  ,54                  ,1100                ,1101                ,1104                ,1105                ,1102                ,1103                ,1108                ,1109                ,1106                ,1107                ,48                  ,49                  ,46                  ,47                  ,1033A               ,40                  ,41                  ,44                  ,45                  ,42                  ,43                  ,807                 ,806                 ,2                   ,808                 ,85                  ,1111                ,1112                ,70                  ,WV10                ,WV11                ,WV12                ,WV13                ,641                 ,WV3                 ,640                 ,WV4                 ,401                 ,643                 ,797B                ,WV1                 ,400                 ,642                 ,797A                ,WV2                 ,3058D               ,3058C               ,E13                 ,3058A               ,E18                 ,WV14                ,2050                ,E19                 ,E16                 ,E17                 ,829                 ,1130                ,828                 ,1133                ,91                  ,1134                ,92                  ,1131                ,1132                ,90                  ,1137                ,821                 ,1138                ,1135                ,823                 ,1136                ,822                 ,825                 ,824                 ,1139                ,826                 ,IFP Mtg Room        ,830                 ,95                  ,96                  ,94                  ,99                  ,97                  ,98                  ,1140                ,818                 ,1141                ,817                 ,819                 ,1144                ,1145                ,1142                ,1143                ,1148                ,4035B               ,1022                ,1149                ,4035C               ,1146                ,812                 ,1147                ,811                 ,814                 ,813                 ,816                 ,815                 ,789                 ,88                  ,89                  ,1151                ,609                 ,1152                ,608                 ,1150                ,1155                ,2002                ,1156                ,2003                ,1153                ,1154                ,2001                ,1159                ,2006                ,4034A               ,601                 ,2007                ,600                 ,1157                ,2004                ,603                 ,1158                ,2005                ,602                 ,605                 ,604                 ,2008                ,607                 ,2009                ,606                 ,3058AA              ,610                 ,2010                ,1160                ,2013                ,3103                ,2014                ,3102                ,2011                ,3101                ,2012                ,3100                ,2017                ,3107                ,832                 ,2018                ,3106                ,831                 ,2015                ,3105                ,2016                ,919                 ,916                 ,917                 ,1001                ,1002                ,1005                ,910                 ,1006                ,911                 ,1003                ,1004                ,1009                ,914                 ,915                 ,1007                ,912                 ,1008                ,913                 ,IR1                 ,IR2                 ,IR3                 ,938A                ,915A                ,820                 ,1052                ,2141                ,1053                ,2142                ,1050                ,1051                ,2140                ,1056                ,2145                ,1057                ,2146                ,1054                ,2143                ,1055                ,2144                ,2149                ,502                 ,744                 ,501                 ,743                 ,1058                ,2147                ,746                 ,1059                ,2148                ,745                 ,748                 ,747                 ,749                 ,751                 ,750                 ,3132A               ,753                 ,752                 ,1063                ,2152                ,3000                ,1064                ,2153                ,1061                ,2150                ";
	var G_MASTER_SHOW = "8B213CE3-638B-43D5-875A-58EDF826A728";
	var G_SHOW = "1D2EA159-A312-4FB5-8FE5-B95879B242BB";
	var G_ADMIN = "yes";
	var CANVASHEIGHT = "355.00000000";
	var G_ACCESS_RIGHTS = "";
	var G_ADMIN_DATASOURCE = "eshow_adminsql";
	var OFFSETY = "5";
	var G_URL_CHAR = "&";
	var LMAPSMETERS = "Feet,Feet,Feet,Feet";
	var BNEWBOOTHMANAGEMENT = "true";
	var G_SHOW_URL = "https://s2.goeshow.com/eshow_programming/programming/testing";
	var G_NET_USER = "no";
	var G_MASTER = "2517EFF6-8063-4454-BA5F-23679F51AD5A";
	var G_EMAIL_DATASOURCE = "eshow_mail";
	var G_CLIENT_DIR = "h:\docs\eshow_programming\client";
	var COOKIE_KEY = "1D2EA159-A312-4FB5-8FE5-B95879B242BB_map_key";
	var GC_SALES_ITEM = "407";
	var G_GOESHOW_ADMIN = "https://admin.goeshow.com";
	var LMAPSKEYIDS = "30093A4B-9FB0-9D1D-CAA9-61ABECC3CDBC,1EBB0174-FB06-3928-A468-8379D2446C1D,004D3361-DB0E-2069-0558-5C0B9D284D7B,F923C378-BDC4-9B52-2A0B-19DB96EA7C77";
	var DATA_SERVER = "eshow_sql002";
	var LANG = "en";
	var IMASTERDRAWINGWIDTH = "550";
	var OFFSETX = "5";
	var INITMAPKEY = "30093A4B-9FB0-9D1D-CAA9-61ABECC3CDBC";
	var LAYERS = "Booth|Ruler|Grid|Warning|Structure|Max 10x10 Layout|Booth Outline|Test Layer|Backdrop";
	var G_DEFAULT = "DE53F6EA-E7D6-4883-9FDE-2B757F794C95";
	var G_ROLE_TYPE = "1";
	var XQUERY_STRING = "?pg=exhibitor/space_management.cfm&pg_key=A900EA2D-F77B-41CC-954C-7804B118473C&xtemplate";
	var IEDITCANVASWIDTH = "400";
	var G_LR_SALES_SHOW = "B37E99B5-6807-4A3B-8DE5-6D1A57FD648B";
	var G_CLIENT = "BA2F0E32-E250-48FE-B09A-C70065E2B789";
	var G_CORPORATE = "C3582978-CA70-4964-9203-AA1B7BFEB4C6";
	var G_SERVER_NAME = "WEB002";
	var METRICMAP = "false";
	var G_GRANTED_ACCESS = "";
	var G_MASTER_CLIENT = "D885B2C5-8F28-4AC0-85E6-F580C8C1566E";


	var maxNumber = 0;
	var myFont = null;
	const STATE_IDLE = 'idle';
	const STATE_PANNING = 'panning';
	var imgObj=document.getElementById('background');
	var zoom = 1;
	var gridObjects =[];
	var gridObjectsToolBox =[];
	
	var	trueWidth = 0;
	var trueHeight = 0;
	
	var snapToGrid = true;
	
	var rulerMode = false;
	var fontSize = 4;
	
	
	var canvasObjects = {};
	
		canvasObjects['1'] = {} ;
		
		canvasObjects['2'] = {} ;
		
		canvasObjects['3'] = {} ;
		
		canvasObjects['4'] = {} ;
		
		canvasObjects['5'] = {} ;
		
		canvasObjects['6'] = {} ;
		
		canvasObjects['66'] = {} ;
				
	
	// var combineCanvas = null;
	var changeCanvas =null;
	var hruler=null;
	var vruler=null;
	
	var boundMiddleX=null;
	var boundCenterY=null;
	var newObjectCounter = 1;
	var groupItems = [];
	var _clipboard = null;
	var renderedSlider=false;
	var extruder = null;
	var panMode = false;
	
	var editZoomLevel = 0;
	var editZoomLevelMin = 0;
	var editZoomLevelMax = 3;
	
	var splitGrid = 20;
	var hideRequest = null;
	var drawingObjects = [];
	
			
	var fontSelected  = null; 
	var toolBoxCanvas = null;
	var drawingMode = false;
	var startMontoringClicks=false;
	var clicks=[];
	var points=[];
	var toolBoxtoolBoxCanvas =null;
	
	var blank =  null;
	var splitCanvas = null;
	var combineCanvas =null;
	var tmpCanvas = null;
	var lens = null;
	var map_data_path = MAP_DATA_PATH;
	var widthResize = WIDTHRESIZE;
	var heightResize = HEIGHTRESIZE;
	var g_tpage = G_TPAGE;
	
	var map_key = G_SHOW;
	var maxNumber = 0;
	var canvasWidth = CANVASWIDTH;
	var canvasHeight = CANVASHEIGHT;
	
	
	var offsetY = 0;
	var offsetX = 0;
	
	
	var heightresize = 0;
	var widthresize = 0;

	var showCompanyName = 0;
	
	
	
	var GRIDSIZE = 10 * Math.round(WIDTHRESIZE);
	
	

	var xMath = 0;
	var yMath = 0;


	var canvasApp ={};
 
	var dataState = {};

	var dataStack = {};

	var FIXCOUNTER =0 ;

	var SPLITING= false;

	Math.sum = function(array){ return array.reduce(function(a, b){
			return a + b;
		}, 0);};


    canvasApp.combineHelper   = new Object({
        lockReload:false,
     	targetX:0,
     	targetY:0,
     	ids:"",
     	fill:"",
     	company_key:"",
     	company_name:"",
     	parent_key:"",
     	status:"",
     	bAllowAssigned:false,
     	lcombinedList:"",
     	combine2:"",
     	maxWidth:0,
     	maxHeight:0,
     	masterCount:0,
     	table:null,
     	filtered:null,
     	booth_group:"",
     	fill_color:"",
     	text_color:"",
     	combined_top:0,
     	companyCombine:false,
		minObject: null,
     	openCompanyCombineWindow:function(){
     	
     		canvasApp.combineHelper.companyCombine = true;
     	
     		//j('#btnCompanyCombine').hide();
				//
     			// canvasApp.mHelper.which="combine";
     	        // canvasApp.mHelper.initModal("modalCompanyCombine");
     	        
     	    if (typeof canvasApp.combineHelper.table !=='undefined' && typeof canvasApp.combineHelper.table.ajax !=='undefined'){
            	
            	if (canvasApp.combineHelper.lockReload==false){
            		canvasApp.combineHelper.lockReload=true;
        
            		canvasApp.combineHelper.table.ajax.reload(function(){
            			
           					canvasApp.combineHelper.lockReload=false;
            			
            		});
            		
            	}
            
            	
            }   
     	        
        	
     	},
     	executeCompanyCombine:function(){
     		
     		let vertics = [];
     		let point = [];
     		let booth = null;
     		let boothNumber = 0;
     		let data = null;
     		let boothNumbers=[];
     		let boothObject=null;
     		let distances=[];
     		let boothKeys=[];
     		let liBoothNumbers="";
     		let totalWidth =0;
     		let totalHeight =0;
     		
     		canvasApp.combineHelper.combined_top = -Infinity;	
     			 	canvasApp.combineHelper.table.rows().every( function ( rowIdx, tableLoop, rowLoop ) {
    						data = this.data();
    						//  if (j(this.node()).hasClass('selected')){
   							// 		boothNumbers.push(data[0]);
   									
   							// 	}
    			 	});
    			 	
    			 	boothNumbers.sort();
    			 	
    			 	for(let ii=0;ii<boothNumbers.length;ii++){
    			 		
    			 		liBoothNumbers = liBoothNumbers + boothNumbers[ii] + ",";
    			 	
    			 	}
    			 	
    			 	
    			 	
    			 	
    			 	Object.keys(canvasObjects[1]).forEach(key =>{
    			 		
   				 			 if (typeof canvasObjects[1][key]['group'] !=='undefined'){
    			 					boothObject = canvasObjects[1][key]['group'];
    			 						if (boothNumbers.includes(boothObject.booth_number)){
    			 									boothKeys.push(key);
    												point = [];
													point.push(boothObject.top);
    												point.push(boothObject.left);
    												vertics.push(point);
    												totalWidth = totalWidth + boothObject.width;
    												totalHeight = totalHeight + boothObject.height;
    												
    												if (canvasApp.combineHelper.combined_top<boothObject.top){
    													canvasApp.combineHelper.combined_top=boothObject.top;	
    												} 
				 							}
				 					}
    			 		
    			 		});
    			 	
    		let line = [];
    		let liCount = vertics.length;
    		let lineCounter = 0;
    		let liCounter = 0;
    		let lines=[];
    		let lineNumber =0;
    		let maxDistance =0;
    	
    		while (liCounter<liCount){
    	
    			line.push(vertics[liCounter]);
    			
    			if (line.length>1){
   					distances[lineNumber]=geometric.lineLength(line);
    				lineNumber++;
    				line.pop();
    			}
   	
    			liCounter++;	
    		}
    		liCounter=liCounter -1;
    		
    		while (liCounter>0){
    	
    			line.push(vertics[liCounter]);
    			
    			if (line.length>1){
   					distances[lineNumber]=geometric.lineLength(line);
    				lineNumber++;
    				line.shift();
    			}
   	
    			liCounter=liCounter-1;
    		}
  			
  		
    		maxDistance = Math.max(...distances);
    		
    		if (maxDistance>totalWidth || maxDistance>totalHeight){
    		
    							
	        				// canvasApp.uHelper.alertBox(' Booth Distances are too far.','Error','error');
	        	 		
	        	 		return;
	        	 								
    			
    		}
    		
    		
    		 this.combineAsssigned(liBoothNumbers);
 		    		
     	},
     	findNearestEmpty:function(targetBoothNumbers,targetBoothKeys){
     		
     		let booths=[];
     		let booth=null;
     		let obooth=null;
     		let pbooths=[];
     		let pbooth =[];
     		let ppoint = [];
     		let maxHeight=0;
     		let maxWidth=0;
     		
     		
     			for(let i=0;i<targetBoothKeys.length;i++){
     					booths.push(canvasObjects[1][targetBoothKeys[i]]);
     					booth = canvasObjects[1][targetBoothKeys[i]];
     					maxHeight=0;
     					maxWidth=0;
    
     					for(let b=0;b<targetBoothKeys.length;b++){
     							if ( targetBoothKeys[i] == targetBoothKeys[b]){
     								continue;			
     							}
     							obooth = canvasObjects[1][targetBoothKeys[i]];
     							maxHeight = maxHeight + obooth.height;
     							maxWidth = maxWidth + obooth.width;
     					}
     							pbooth = [];
     							pbooth.push([booth.left-maxWidth,booth.top-maxHeight]);
     							pbooth.push([booth.left+maxWidth,booth.top-obooth.height]);
     							pbooth.push([booth.left+maxWidth,booth.top+obooth.height]);
     							pbooth.push([booth.left-maxWidth,booth.top+obooth.height]);
     							
     			}
     			
     		
     		
     	},
        openCombineWindow:function(preview=false, newBoothNumberLabel= false){

        
        	canvasApp.combineHelper.companyCombine=false;
         	
         	if (canvasApp.selectionHelper.selected()==false){
                	
                	return false;
             }
             
        		this.masterCount=0;   
             
            	// combineCanvas.clear();
            	
            	this.targetX=canvasApp.selectionHelper.left;
            	this.targetY=canvasApp.selectionHelper.top;
            	
            	
            	//j('#modalCombineinBoothNumber').html();


            	var combinedWidth =0;
                var combinedHeight =0;
                var lowestX =0;
                var lowestY =0;
                
                let hotspot = false;
                let assigned = false;
                let objectsInGroup = canvasApp.selectionHelper.getObjects();
                let newBoothNumber="";
                let aBoothNumbers=[];
                let counter=[];
                let distances={};

                canvasApp.combineHelper.parent_key="";
                canvasApp.combineHelper.company_key="";
                canvasApp.combineHelper.company_name="";
                canvasApp.combineHelper.status="";

				
				let objGrp = [];
				  objectsInGroup.forEach(function(object) {
                     if (object.get('hotspot')!==true){
						objGrp.push(object);
					}                         
                  });
                  
                  if ( objGrp.length<2){
              
               		 
                    	// canvasApp.uHelper.alertBox(' Select more than 1 booth','Error','error');
                	 
                    return false;
                  	
                  }
                  
                  objectsInGroup = objGrp;
                   
                let booth_numbers="";
                //   canvasApp.safetyHelper.startEditing();
                // 					this.maxWidth = 0;
				// 					this.maxHeight =0;
									
				canvasApp.combineHelper.booth_group="";
				canvasApp.combineHelper.fill_color="";
				canvasApp.combineHelper.text_color="";				
                 /// Need this to help with status look up for sold booths hold
                 /// gets status and default colors
                    objectsInGroup.forEach(function(object) {
                    	
                    	   if (typeof object.get('booth_group') !='undefined' &&  object.get('booth_group').length>0){
    								canvasApp.combineHelper.booth_group=object.get('booth_group');
    					 
    					 	}
                   
                         if (typeof object.get('status') !='undefined' &&  object.get('status').length>0 && canvasApp.combineHelper.status.length==0){
                            	 canvasApp.combineHelper.status= object.get('status'); 
                            		 if ( canvasApp.combineHelper.status == "not_priced"){
                            			 canvasApp.combineHelper.fill_color=canvasApp.colorHelper.get(canvasApp.combineHelper.status);
                        	    		 canvasApp.combineHelper.text_color=canvasApp.colorHelper.overlayColor(canvasApp.combineHelper.fill_color);
                            	 	
                            	 	}
                            }
                   }); 
                   
                   if (canvasApp.combineHelper.booth_group !="")
                   {
                        canvasApp.combineHelper.fill_color=canvasApp.colorHelper.getBoothGroupColor(canvasApp.combineHelper.booth_group,
                        canvasApp.combineHelper.status);
                        canvasApp.combineHelper.text_color=canvasApp.colorHelper.overlayColor(canvasApp.combineHelper.fill_color);
                   	}
                   
                    objectsInGroup.forEach(function(object) {
                            if (!counter.includes(object.get('id'))){
                                counter.push(object.get('id'));
                            }
                            if (object.get('hotspot')===true){
                            	hotspot=true;
                            }
                            
                          
                            
                            if (canvasApp.combineHelper.bAllowAssigned==true){
                            	if (typeof object.get('company_key') !='undefined' &&  object.get('company_key').length>0){
                            		if (canvasApp.combineHelper.company_key.length>0 && canvasApp.combineHelper.company_key != object.get('company_key')
                            		&& canvasApp.combineHelper.parent_key.length>0 && canvasApp.combineHelper.parent_key != object.get('parent_key')){
                            			
                            			assigned=true;
                            		}
                             		canvasApp.combineHelper.company_key=object.get('company_key');
                            		canvasApp.combineHelper.company_name=object.get('company_name');
                            		canvasApp.combineHelper.parent_key=object.get('parent_key');
                            		
                            		if (canvasApp.combineHelper.company_key.length==36){
                         					canvasApp.combineHelper.fill_color=canvasApp.colorHelper.get(canvasApp.combineHelper.status);
        		
                            			}
                            	}
                            }
                            if (canvasApp.combineHelper.bAllowAssigned==false){
                            
                            
                            	if (typeof object.get('company_key') !='undefined' &&  object.get('company_key').length>0){
                            			assigned=true;
                            	}
                            }
                            
                            
                            
                            if (typeof object.get('booth_number') != 'undefined'){
        						 canvasApp.combineHelper.masterCount= canvasApp.combineHelper.masterCount+1;   
        
                            		booth_numbers = booth_numbers + String(object.get('booth_number')) + " ";
               					 	// canvasApp.safetyHelper.addEditing(object.get('booth_number'));
                            	 	aBoothNumbers.push(String(object.get('booth_number'))); 

                            	//  canvasApp.safetyHelper.addEditing(String(object.get('booth_number')));

												distances[object.get('booth_number')]=[];
                            	 				distances[object.get('booth_number')][0]=object.get('left');
                            	 				distances[object.get('booth_number')][1]=object.get('left')+(object.get('width') /widthResize);
                            	 				distances[object.get('booth_number')][2]=object.get('top');
                            	 				distances[object.get('booth_number')][3]=object.get('top')+(object.get('height') /heightResize);

									 canvasApp.combineHelper.maxWidth =  canvasApp.combineHelper.maxWidth + object.get('width')/widthResize;
									 canvasApp.combineHelper.maxHeight =  canvasApp.combineHelper.maxHeight +  object.get('height')/heightResize;
                            	 
                            }
                            
                            if (typeof object._objects !=="undefined"){
                            	object._objects.forEach(function(obj){
              	    						if (!counter.includes(obj.get('id'))){
                                				counter.push(obj.get('id'));
                            					}
                            				if (obj.get('hotspot')===true){
                            					hotspot=true;
                            				}
                            				if (typeof obj.get('company_key') !='undefined' &&  obj.get('company_key').length>0){
                            					assigned=true;
                            				}
                            				if (typeof obj.get('booth_number') != 'undefined'){
                            					 
                            					canvasApp.combineHelper.masterCount= canvasApp.combineHelper.masterCount+1;  
                            				  	booth_numbers = booth_numbers + String(obj.get('booth_number')) + " ";
               					 				// canvasApp.safetyHelper.addEditing(obj.get('booth_number'));
                            					aBoothNumbers.push(String(obj.get('booth_number'))); 
                            	 				// canvasApp.safetyHelper.addEditing(String(obj.get('booth_number')));
                            	 				
                            	 				distances[obj.get('booth_number')]=[];
                            	 				distances[obj.get('booth_number')][0]=obj.get('left');
                            	 				distances[obj.get('booth_number')][1]=obj.get('left')+(obj.get('width') *widthResize);
                            	 				distances[obj.get('booth_number')][2]=obj.get('top');
                            	 				distances[obj.get('booth_number')][3]=obj.get('top')+(obj.get('height') *heightResize);

													 canvasApp.combineHelper.maxWidth =  canvasApp.combineHelper.maxWidth + object.get('width')/widthResize;
													 canvasApp.combineHelper.maxHeight = canvasApp.combineHelper.maxHeight +  object.get('height')/heightResize;
                            	 
                           					 }
              	    			});
              	    		}
                            
                            
                    });
                    		
     				
                 	
                 	
                if (aBoothNumbers.length < 2){
               
               		 
                    	// canvasApp.uHelper.alertBox(' Select more than 1 booth','Error','error');
                	 
                    return false;
                    
                }
                if (hotspot==true){
                
                	 
                    // canvasApp.uHelper.alertBox(' Hotspots cannot be combined','Error','error');
                	 
                
                    return false;
                 	
                }
                if (assigned==true && this.bAllowAssigned==true){
                	 
                    // canvasApp.uHelper.alertBox(' Assigned Booths cannot be combined when assigned to different companies','Error','error');
                	 
                
                   return false;
                 	
                }
                
                if (assigned==true && this.bAllowAssigned==false){
                	
                    // canvasApp.uHelper.alertBox(' Assigned Booths cannot be combined.','Error','error');
                	 
                
                   return false;
                 	
                }

                if(!newBoothNumber){
					if (aBoothNumbers.length>0){
						//  aBoothNumbers.sort();
						 var sorted = aBoothNumbers.sort((a, b) =>a*1-b*1);
						 newBoothNumber=sorted[0];
				  	}
				}
                    
                 
                    this.ids=counter.join(' ');
                    
                 	//j('#modalCombineinBoothNumber').html(booth_numbers);
				 //
              	// canvasApp.mHelper.which="combine";
                // canvasApp.mHelper.initModal("modalCombine");
                
                let pbAPoints=[];
                
                // COMBINE HELPER
                
                let aPoints=[];
           		var tmp = this.tranferObjectsToEditingWindow(null,canvasApp.helperCanvas)
				if(!tmp) return false
                aPoints.push(tmp); //
                
                let Xs =[];
                let Ys =[];
                
                
                let tmpPoints = aPoints[0];
                
                let tPoint = [];
                
                for(let xy=0;xy<tmpPoints.length;xy++){
                	tPoint = tmpPoints[xy];
                	Xs.push(tPoint[0]);
                	Ys.push(tPoint[1]);
                }
                
                
                let MnXs=Math.min(...Xs);
                let MnYs=Math.min(...Ys);
                
                	if (MnXs<0){
                		MnXs = 0-MnXs; 
                	}
                	if (MnYs<0){
                		MnYs = 0-MnYs; 
                	}
                	
                
                 for(let xxy=0;xxy<tmpPoints.length;xxy++){
                 	tmpPoints[xxy][0]=tmpPoints[xxy][0]+MnXs;
                	tmpPoints[xxy][1]=tmpPoints[xxy][1]+MnYs;
                 }
                
                 aPoints[0]=tmpPoints;
                
               	canvasApp.combineHelper.bAllowAssigned=false;
             	
                return this.buildItemsFromPolypointsTurf(aPoints,canvasApp.helperCanvas,newBoothNumber, objectsInGroup, preview, newBoothNumberLabel); //
	
        },
        buildItemsFromPolypointsTurf:function(aPoints,canvasToAdd,newBoothNumber, objectsInGroup, preview, newBoothNumberLabel){
        	/// new one to work with Turf 
        	//  bounds is top left [0,0], bottom right [10,10]
        	
        	const distinct = (value, index, self ) =>{
        		return self.indexOf(value) === index;
        	}
        	
        	// aPoints[0].push(aPoints[0][0]);
        	let x=[];
        	let y=[];
        	let rotated =[];
        	
        	let startX=0;
        	let startY=0;
        	let angle=0;
        	let angleKeys=[];
        	let angles=[];
        	let anglekey="";
        	let loopX =0;
        	let loopY =0;
        	
			
			//	relativex: bPoints[0],
    		//			relativey: bPoints[1],
			
			let bounds = geometric.polygonBounds(aPoints[0]);
			
			
			let modSupposedToBeX = canvasApp.combineHelper.maxWidth % 10;
		   	let modSupposedToBeY = canvasApp.combineHelper.maxHeight % 10;
		  	let width = geometric.lineLength([bounds[0],[bounds[1][0],bounds[0][1]]])
        	let height = geometric.lineLength([bounds[0],[bounds[0][0],bounds[1][1]]])
         	
        	
        	let polygonPoints=[];
        	let ppX =0;
        	let ppY =0;
    		let ppL = 0;
    		let lppX =0;
    		let lppY =0;
    		let YY =[];
    		let XX =[];
    		
			ppX=Math.round(aPoints[0][0][0]);
			ppY=Math.round(aPoints[0][0][1]);
			if (Math.round(ppX) % 10  != modSupposedToBeX ){
					ppX=ppX- (( ppX % 10) - modSupposedToBeX);

				
			}
			if (Math.round(ppY) % 10  != modSupposedToBeY ){
					ppY=ppY- (( ppY % 10) - modSupposedToBeY);
			}

			lppX=ppX;
			lppY=ppY;
						
			// polygonPoints.push(new fabric.Point(ppX,ppY));
			
			YY.push(ppY);
			XX.push(ppX);
				
			var pathPointsArray = [];
	
        	if(0){
				for(let mastercounter=1;mastercounter<aPoints[0].length;mastercounter++){
					ppX=Math.round(aPoints[0][mastercounter][0]);
					ppY=Math.round(aPoints[0][mastercounter][1]);
					
					var llY=geometric.lineLength([
											[lppX,lppY]
											,
											[ppX,ppY]
											]);
				
					if (Math.round(llY) % 10  != modSupposedToBeY ){
						 
						if ( ppY % 10 != modSupposedToBeY ){
							ppY=ppY- (( ppY % 10) - modSupposedToBeY);
							
						}
						if ( ppX % 10 != modSupposedToBeX ){
								ppX=ppX- (( ppX % 10) - modSupposedToBeX);
		
						}
						
					}
				
					llY=geometric.lineLength([
											[lppX,lppY]
											,
											[ppX,ppY]
											]);
				
					
					
					YY.push(ppY);
					XX.push(ppX);
					polygonPoints.push(new fabric.Point(ppX,ppY));
					lppX=ppX;
					lppY=ppY;
		
				
				}
			}
			
        	for(let mastercounter=0;mastercounter<aPoints[0].length;mastercounter++){
				ppX=(aPoints[0][mastercounter][0]);
				ppY=(aPoints[0][mastercounter][1]);
				
				polygonPoints.push(new fabric.Point(ppX,ppY));
				pathPointsArray.push({x:ppX, y:ppY})
				lppX=ppX;
				lppY=ppY;
	
			
			}
			pathPointsArray.push({x:aPoints[0][0][0], y:aPoints[0][0][1]})
			
			let xcount=0;
			let ycount=0;
			let newPoly=[];
			
			
			
			
			let newFill = "#dadada";
			let borderColor = '#ff7777';
			 
	
			if (canvasApp.combineHelper.fill_color.length>0){
				newFill = canvasApp.combineHelper.fill_color; 	
			}
			else{
				canvasApp.combineHelper.fill_color=newFill;
			}
			
			canvasApp.combineHelper.text_color = "black"; 
			
			var convertRateX= 1
			var convertRateY= 1
			if(canvasToAdd.convertRateX) {
				var convertRateX= Math.abs(canvasToAdd.convertRateX)
				var convertRateY= Math.abs(canvasToAdd.convertRateY)
			}
			
			var selection = canvasToAdd.getActiveObject();
			
			if(!preview) 
				canvasToAdd.discardActiveObject();
			angle = 0;
			var rotatedPath = rotatePath(pathPointsArray)
			angle = rotatedPath.angle
			var newPoints = rotatedPath.points
			var newLeft = rotatedPath.left
			var newTop = rotatedPath.top
			var new_polygonPoints = [];
			let imageObject = new fabric.Polygon(
				newPoints, {					
				class:"outline",
				left : this.minObject.left,
				top : this.minObject.top,
				fill: newFill, 
				stroke: 'black',
				strokeWidth: getStrokeWidth(canvasToAdd),
				borderColor: 'black',
				lockRotation: true,
				lockScalingX: true,
				lockScalingY: true,
			});
			var orgObject;
			// var sorted = objectsInGroup.sort((a, b) =>a.booth_number*1-b.booth_number*1);
            // orgObject=sorted[0];

			objectsInGroup.forEach(function(object) {
				if(object.booth_number == newBoothNumberLabel){
					orgObject = object; return;
				}
			});
			let groupObject =   new fabric.Group([imageObject],{
					width:imageObject.width,
					height:imageObject.height,
					id: 'booth-'+newBoothNumberLabel,
					class: 'booth',
					class1 : 'booth-group',
					lockRotation: true,
					lockScalingX: true,
					lockScalingY: true,
					booth_number: newBoothNumberLabel?newBoothNumberLabel:newBoothNumber
			});	
			groupObject.set({
				borderColor: '#ff7777',
				cornerColor: 'red',
				cornerSize: 6,
				transparentCorners: false,
				angle: preview?0:canvasToAdd.gridAngle*1
			});
			if(this.minObject && this.minObject.angle > 0){
				groupObject.set({
					angle:this.minObject.angle
				})
			}
			if(!preview) 
				canvasToAdd.add(groupObject)
			
			// imageObject.clone(function(cloned) {
			// 	groupObject.clipPath = cloned                                    
			// });
			

			
			
			if(orgObject){
				groupObject.set(buildObjectProperty(orgObject));
				var bgColor = "#dadada"
				var objects = orgObject.getObjects('polygon')
				for(var i = 0; i < objects.length; i++){
					var bgObject = objects[i]; 
					bgColor = bgObject.fill;
					break;
				}
				setObjectBG(canvasToAdd, groupObject, bgColor)
				groupObject.new_created = true;
				groupObject.uniq_id = Date.now() + parseInt(Math.random()*10000000000)
			}
			else{
				groupObject.modified = true;
			}
			var newText = (orgObject?.company?(orgObject.company+"\n"):"")+(newBoothNumberLabel?newBoothNumberLabel:newBoothNumber)
			addText(canvasToAdd, groupObject, newText)
			var objects = selection.getObjects();
			var tmp = [];
            for(var i = 0; i < objects.length; i++){
                var json = objects[i].toDatalessObject()
                json.left = json.left - selection.left
                json.top = json.top - selection.top
                tmp.push(json)
            }   
            groupObject.child_booths = tmp
			if(preview) 
				return groupObject;
			
			selection.getObjects().forEach(function(object){
				canvasToAdd.remove(object)
			})

			return groupObject;
		          	
			
		          				
					
			
			
        	// const pl = polylabel([newPoly], 1.0);
			
			// let oy='top';
			// if (pl[1]==0){
			// 	oy='center';
			//     pl[1]=10;
			// }
			//     pl[0]=pl[0]+3;
			
			
				
			
		    	
		    	 
					//j('#combinedWidth').val(width);
					//j('#combinedHeight').val(height);
					
					
			
			
        	
        },
      	buildItemsFromPolypoints:function(aPoints,canvasToAdd,newBoothNumber){
			
			let masterSize=aPoints.shift();
			
			
			// if (typeof newBoothNumber === 'undefined' || newBoothNumber.length==0){
			// 	newBoothNumber =String(canvasApp.safetyHelper.getObjectNumber());
			// }
			
			
			let polygonPoints=[];
			let labelPoints=[];
			let targetPoints=[];
			for (let iaPoint=0;iaPoint<aPoints.length;iaPoint=iaPoint+2){
				
				if (typeof aPoints[iaPoint] !=='undefined' || typeof aPoints[iaPoint+1] !=='undefined' ){
				
				
					labelPoints.push([aPoints[iaPoint], aPoints[iaPoint+1]]);
	
				}
				

				polygonPoints.push(new fabric.Point(aPoints[iaPoint], aPoints[iaPoint+1]));
			
			}
			for (let counter=0;counter<labelPoints.length-1;counter=counter+1){
				
				
				if ( (labelPoints[counter][0] != labelPoints[counter+1][0]) ||
					(labelPoints[counter][1] != labelPoints[counter+1][1]) ){
			
			
						targetPoints.push([labelPoints[counter][0], labelPoints[counter][1]]);
			
					
				}
			
			}	
			
			
					targetPoints.push(labelPoints[labelPoints.length-1]);
				
					targetPoints.push(targetPoints[0]);
					
					
					
			for(let mastercounter=0;mastercounter<targetPoints.length;mastercounter++){
				
				polygonPoints.push(new fabric.Point(targetPoints[mastercounter][0], targetPoints[mastercounter][1]));
			
			}		
			
			const pl = polylabel([targetPoints], 1.0);
			
		
			
			
		       let imageObject	= new fabric.Polygon(polygonPoints,{
	    				fill: canvasApp.colorHelper.get('available'),
	    				stroke: canvasApp.colorHelper.get('border'),
	    				relativex: masterSize[0],
    					relativey: masterSize[1],
	    				strokeWidth: 1,
	    	    		sub_type: 1,
	            		selectable:false,
	            		hoverCursor: 'pointer'
	            		});
	            		
	            let groupObject =   new fabric.Group([imageObject],{
	    				left:  0,
	    				top:0, 
	    				width: masterSize[2],
	        		   	height: masterSize[3],
	    				fill: canvasApp.colorHelper.get('available'),
	    				stroke: canvasApp.colorHelper.get('border'),
	                		strokeWidth: 1,
		            		selectable:false,
		            		hasControls:false,
		            		id: 'combined'	
		          	});
		          	
		          				
					
			/// HERE for objectNUmber
	           let textObject= new fabric.IText(newBoothNumber, {
	 						fontSize: fontSize,
	  						originX: 'center',
	    					originY: 'center',
	  						textAlign: 'center',
	  						left: pl[0],
	    					top: pl[1]
					});
	    		 
				 let zoomLevelW=300/masterSize[2];
				 let zoomLevelH=300/masterSize[3];
				 
				 let zoomLevel =1;	
				 zoomLevel=zoomLevelW;
			
				 
				 if (zoomLevelW>zoomLevelH){
				 	zoomLevel=zoomLevelH;
				 }
				 
				 
				canvasToAdd.add(groupObject);
			 	canvasToAdd.add(textObject);
			 
		    	 canvasToAdd.setZoom(zoomLevel);
		         canvasToAdd.setWidth((masterSize[2]+1)*zoomLevel);
		    	 canvasToAdd.setHeight((masterSize[3]+1)*zoomLevel);
		    	 canvasToAdd.renderAll();
		    	 
		    	var combinedWidth=canvasApp.combineHelper.maxWidth;
				var combinedHeight=canvasApp.combineHelper.maxHeight;
		
					//j('#combinedWidth').val(combinedWidth);
					//j('#combinedHeight').val(combinedHeight);
				
			
		},
		combineAsssigned:function(listBoothNumbers){
			
			this.bAllowAssigned=true;
			let boothNumbers=listBoothNumbers.split(',');
			let smallestBoothNumber=Math.min(...boothNumbers);
			let booths=[];
			let aLefts =[];
			let aTops =[];
			// snapToGrid=false;
   		
   				canvasApp.helperCanvas.discardActiveObject();
        		
				let objects = canvasApp.helperCanvas.getObjects();
				let lastLeft =0;
				let lastTop =0;
				let direction = "L";
				/// HERE SAI 
				// aLefts.sort();
              	//		aTops.sort();
              	let sortedY = [];
              	let sortedX = [];
              	let sortedObjects = [];
              	let sortKey="";
              	let boothNumberAdded=[];
              		objects.forEach(function(object){
              				if (typeof object.get('booth_number') !=='undefined' && object.get('booth_number') !=='' 
							&& boothNumbers.includes(object.get('booth_number'))){
	          					sortedX.push(object.get('left'));
              					sortedY.push(object.get('top'));
              				}
              		});
              		sortedX.sort();
              		sortedY.sort();
        
        			
              		sortedX.forEach(function(sortX){
              			sortedY.forEach(function(sortY){
              					objects.forEach(function(object) {
              						if (typeof object.get('booth_number') !=='undefined' 
              								&& object.get('booth_number') !==''
											&& boothNumbers.includes(object.get('booth_number'))){
										if (! boothNumberAdded.includes(object.get('booth_number'))){ 
											
	          								if (object.get('left')==sortX && object.get('top')==sortY){
              									  sortedObjects.push(object);
              								  	boothNumberAdded.push(object.get('booth_number'));
              								}
              							}
              						}
              					});
              			});
              		});
              		
              			
              		booths=sortedObjects;
					lastLeft =0;
					lastTop =0;
				let sel = new fabric.ActiveSelection(booths, {
          				canvas: canvasApp.helperCanvas,
        		});
        		canvasApp.helperCanvas.setActiveObject(sel);
        		canvasApp.helperCanvas.requestRenderAll();
        		
        		 this.openCombineWindow();
			
			
		},
		combiningBoothNumbers:function(listBoothNumbers)
		{
			let listChargeKeys = canvasApp.detailHelper.charge_keys;
			let listBoothKeys = canvasApp.detailHelper.booth_keys;
			
			if (listChargeKeys.length<36 || listChargeKeys.length<36){
				 
                    // canvasApp.uHelper.alertBox(' Could not determine selected booths.','Error','error');
                 
              	return false;	
			}
			
			let aChargeKeys = listChargeKeys.split(',');
			let aBoothKeys = listBoothKeys.split(',');
			
			if (aChargeKeys.length != aBoothKeys.length ){
				 
                    // canvasApp.uHelper.alertBox(' Could not determine selected booths/charges inequal amounts.','Error','error');
                 
              	return false;	
			}
			
			this.lcombinedList =""; 
			
			for (let i=0;i<aChargeKeys.length;i++){
					
					if (aChargeKeys[i].length == 36 && aBoothKeys[i].length == 36){
							this.lcombinedList = this.lcombinedList +  aChargeKeys[i] + "|";  
					}
					
			}
			
			if (this.lcombinedList.length <72 ){
				 
                    // canvasApp.uHelper.alertBox(' Could not determine selected booths/charges bad indexes.','Error','error');
                 
              	return false;	
			}
			

			this.combineAsssigned(listBoothNumbers);
			
		},
	    tranferPolygonObjectsToEditingWindow:function(targetCanvas,sourceCanvas,abox)
	    {
	    	
	    	
	    	/// POLYGON NEW 
	 			 let allPoints=[];   	    
                 let points=[];
                 let ypoints=[];
                 let ykeys=[];
                 let xpoints=[];
			     let objectsInGroup = canvasApp.selectionHelper.getObjects();
                 
                 let childObjects=null;
                 let childPoints=null;
                 let instance={};
                 let newInstances=[];
        		 let returnArray=[];
              	 let minX=Infinity;
              	 let minY=Infinity;
              	 let minXX=Infinity;
              	 let minYY=Infinity;
              	 
              	 let maxX=-Infinity;
              	 let maxY=-Infinity;
              	 let maxXX=-Infinity;
              	 let maxYY=-Infinity;
              	 let mX=0;
              	 let mY=0;
              	 let mXX=0;
              	 let mYY=0;
              	 
              	 let newX=0;
              	 let newY=0;
              	 let objCounter=0;
              	 
              	 
              	 
              	    objectsInGroup.forEach(function(object) {
              	     	
              	     		childPoints=null;
        
              	     		childObjects = object._objects.forEach(function(childobj){
              	     			if (typeof childobj.points !=='undefined'){
              	     				childPoints=childobj.points;
              	     			}
              	     		});
 
              	     		if (childPoints != null){
              	     		
              	     			for (let i=0;i<childPoints.length;i++){
									
									if (childPoints[i].x<minX){
										minX=childPoints[i].x;
									}			
              						if (childPoints[i].y<minY){
										minY=childPoints[i].y;
									}
									
											
									if (childPoints[i].x>maxX){
										maxX=childPoints[i].x;
									}			
              						if (childPoints[i].y>maxY){
										maxY=childPoints[i].y;
									}			
              	    			
              	    
              	     			}
              	     			
              	     		}
              	     		else{
              	     			
              	     			if (object.aCoords.tl.x<minXX){
              	     				minXX=object.aCoords.tl.x;
              	     			}
              	     			
              	     			if (object.aCoords.tl.y<minYY){
              	     				minYY=object.aCoords.tl.y;
              	     			}
 
 
 								 if (object.aCoords.br.x>maxXX){
              	     				maxXX=object.aCoords.br.x;
              	     			}
              	     			
              	     			if (object.aCoords.br.y>maxYY){
              	     				maxYY=object.aCoords.br.y;
              	     			}
 
              	                   	    
              	     		}
              	    
                    });
                    
                    if (maxX==-Infinity){
                    	maxX=maxXX;
                    }
                    
                    if (maxY==-Infinity){
                    	maxY=maxYY;
                    }
                    
                    
                    if (maxXX==-Infinity){
                    	maxXX=maxX;
                    }
                    
                    if (maxYY==-Infinity){
                    	maxYY=maxY;
                    }
                    
                    
                    if (maxYY>maxY){
                    	maxY=maxYY;
                    }
                    
                   	if (maxXX>maxX){
                    	maxX=maxXX;
                    }
                                	 
                     objectsInGroup.forEach(function(object) {
              	     	
              	     		allPoints=[];
              	     	 	newInstances[objCounter]=[];
              	     		childPoints=null;
        
              	     		childObjects = object._objects.forEach(function(childobj){
              	     			if (typeof childobj.points !=='undefined'){
              	     				childPoints=childobj.points;
              	     			}
              	     		});
              	     		
              	     		if (childPoints != null){
              	     			
              	     			for (let i=0;i<childPoints.length;i++){
              	     				instance= {};
              	     				instance.x=childPoints[i].x-minX;
              	     				instance.y=childPoints[i].y-minY;
              	     				allPoints.push(instance);				
					
              	     			}
              	     		}
              	     		else{
              	     				instance= {};
              	     				instance.x=object.aCoords.br.x-minXX;
              	     				instance.y=object.aCoords.br.y-minYY;
              	     				allPoints.push(instance);				

              	     				instance= {};
              	     				instance.x=object.aCoords.bl.x-minXX;
              	     				instance.y=object.aCoords.bl.y-minYY;
              	     				allPoints.push(instance);	
              	     				
              	     				
              	     				instance= {};
              	     				instance.x=object.aCoords.tr.x-minXX;
              	     				instance.y=object.aCoords.tr.y-minYY;
              	     				allPoints.push(instance);	
              	     				
              	     				instance= {};
              	     				instance.x=object.aCoords.tl.x-minXX;
              	     				instance.y=object.aCoords.tl.y-minYY;
              	     				allPoints.push(instance);	
              	     							
			  	     		}
			  	     		
			  	     		newInstances[objCounter]=allPoints;
			  	     		
			  	     		objCounter++;
              	    
                    });
                    
                    let aPoint=[];
                    let blnOkayToAdd=false;
                    
                 
                   	for(let i=0;i<objCounter;i++){
      					instance = newInstances[i];
      					
      					blnOkayToAdd=true;
      					
      				 	for(let ii=i;ii<objCounter;ii++){
      				 		
      				 		
                			if (instance.x==newInstances[ii].x && instance.y==newInstances[ii].y){
                				
                    				blnOkayToAdd=false;
                			}
                	
                					
                			if (instance.x==newInstances[ii].x && instance.y<newInstances[ii].y){
                				
                    			//	blnOkayToAdd=false;
                			}
                			
               	 			if (instance.x<newInstances[ii].x && instance.y==newInstances[ii].y){
                				
                    			//	blnOkayToAdd=false;
                			}
               
                				
      					}	
      					
      					if (blnOkayToAdd==true){
      						if ( this.compareInstances(instance.x,instance.y,allPoints)==false ){
      							returnArray.push(instance);
      						}	       
                		
                		}
                	}
                 
                   	
                   	
                   	let begin = returnArray.shift();
                   	returnArray.push(begin);
                   	returnArray.unshift(begin);
                   	returnArray.unshift(abox);
               
                	
                return returnArray;
        },
        getMaxX:function(x,y,targets){
        	let maxX = x;
         	 for(let i=0;targets.length;i++){
        		if (targets.y==y && targets.x>maxX ){
        			maxX=targets.x;
        		}
        	}
      		return maxX;  
        },
        getMaxY:function(x,y,targets){
        	let maxY = y;
         	 for(let i=0;targets.length;i++){
        		if (targets.x==x && targets.y>maxY ){
        			maxY=targets.y;
        		}
        	}
      		return maxY;  
        },    
        getNearestY:function(x,y,targets){
        	 for(let i=0;targets.length;i++){
        		if (targets.y>y && targets.x==x){
        			return targets.y;
        		}
        		
        	}
      		return y;  
        	
        },  
        getNearestX:function(x,y,targets){
        	for(let i=0;targets.length;i++){
        		if (targets.x>x && targets.y==y){
        			return targets.x;
        		}
        		
        	}
        	return x;  	
        },    
        compareInstances:function(x,y,points){
        	
     
        	for(let i=0;i<points.length;i++){
        		if (points[i].x==x && points[i].y==y){
        			
        			return true;
        		}
        	}
        	
      		return false;  	
        }, 
        getSegment:function(allcoords,position){
        	
        	let returnArray=[];
        	let value = null;
        	for(let index=0;index<allcoords.length;index++){
        		
        		returnArray.push(this.removeSinglePixel(allcoords[index][position]));
        		
        	}
        	
        	return returnArray;
        	
        },
        getAllCoordsSorted:function(coords,subtractor){
        	
        		let returnArray=[];
        		let count=coords.length;
        		let uArray=[];
        		const distinct = (value, index, self)=>{
                    	return self.indexOf(value) === index;
                 };
                 
        		
        		for(let index=0;index<count;index++){
        			
                    		returnArray.push(coords[index]-subtractor);
                    		
                }
                // make the array unique 
                returnArray = returnArray.filter(distinct);
                // sort the array small to large
                returnArray.sort(function(a, b){return a-b});
            //    uArray.push(returnArray[0]);
                return returnArray;
        	
        }, 
        processObjectsIntoLines:function(coords){
      		let x=null;
      		let y=null;
      		
      		let returnCoords=[];
      		let counter=0;
      		
      
      		  for(let ol=0;ol<coords.length;ol++){
             			x=coords[ol].x;
             			y=coords[ol].y;
             			var tempArray = []
             			var ycounter = 0;
             			 if ((coords[ycounter].x)==x){
                   				tempArray.push(coords[ycounter].y);
                    	 }
             
             
             
              }
      		
        	
        	return returnCoords;
        	
        },
        processObjectsIntoPoints:function(objectsInGroup){

  				 let childObjects = null;
                 let counter=0;
                 let coords = [];
                 
                
				        objectsInGroup.forEach(function(object) {
				        	
				        	
              	     		childObjects = object._objects.forEach(function(childobj){
              	     			
              	     		
              	     			if (childobj.type=='group'){
              	     			
             	   			 		if (typeof childobj.aCoords.tl.x !=='undefined'){
            							coords[counter]={x:0,y:0};	     	
              		  					coords[counter].x=childobj.aCoords.tl.x;
              						}
              						if (typeof childobj.aCoords.tl.y !=='undefined'){
              							coords[counter].y=childobj.aCoords.tl.y;
              							counter++;
              						}
              						
              						if (typeof childobj.aCoords.tr.x !=='undefined'){
            							coords[counter]={x:0,y:0};	     	
              		  					coords[counter].x=childobj.aCoords.tr.x;
              						}
              						if (typeof childobj.aCoords.tr.y !=='undefined'){
              							coords[counter].y=childobj.aCoords.tr.y;
              							counter++;
              						}
 
             
              						if (typeof childobj.aCoords.br.x !=='undefined'){
              							coords[counter]={x:0,y:0};	     	
              							coords[counter].x=childobj.aCoords.br.x;
              						}
              						if (typeof childobj.aCoords.br.y !=='undefined'){
              							coords[counter].y=childobj.aCoords.br.y;
              							counter++;
              						}
              						
              						             
              						if (typeof childobj.aCoords.bl.x !=='undefined'){
              							coords[counter]={x:0,y:0};	     	
              							coords[counter].x=childobj.aCoords.bl.x;
              						}
              						if (typeof childobj.aCoords.bl.y !=='undefined'){
              							coords[counter].y=childobj.aCoords.bl.y;
              							counter++;
              						}
              						
              						}

              	   	   		});
              	   	   		
              	   	  
              	   	  
              	   	  		
              	 			if (object.type=='group'){
              	    
              	     
	              	 			if (typeof object.aCoords.tl.x !=='undefined'){
	              					coords[counter]={x:0,y:0};	     	
	              					coords[counter].x=object.aCoords.tl.x;
	              				}
	              				if (typeof object.aCoords.tl.y !=='undefined'){
	              					coords[counter].y=object.aCoords.tl.y;
	              					counter++;
	              				}
	              	 			if (typeof object.aCoords.tr.x !=='undefined'){
	              					coords[counter]={x:0,y:0};	     	
	              					coords[counter].x=object.aCoords.tr.x;
	              				}
	              				if (typeof object.aCoords.tr.y !=='undefined'){
	              					coords[counter].y=object.aCoords.tr.y;
	              					counter++;
	              				}
	             
             
	              				if (typeof object.aCoords.bl.x !=='undefined'){
	              					coords[counter]={x:0,y:0};	     	
	              					coords[counter].x=object.aCoords.bl.x;
	              				}
	              				if (typeof object.aCoords.bl.y !=='undefined'){
	              					coords[counter].y=object.aCoords.bl.y;
	             	 				counter++;
	              				}
	             
	              				if (typeof object.aCoords.br.x !=='undefined'){
	              					coords[counter]={x:0,y:0};	     	
	              					coords[counter].x=object.aCoords.br.x;
	              				}
	              				if (typeof object.aCoords.br.y !=='undefined'){
	              					coords[counter].y=object.aCoords.br.y;
	             	 				counter++;
	              				}
	              				
              				}
              				
                    });

                 
			
			return coords;
        	
        },
        getMinY:function(x,coords){
        	
        		let tempArray =[];
                for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)==x){
                   				tempArray.push(coords[ycounter].y);
                    	 }
                }
             return Math.min(...tempArray);
        	
        },
        getMaxY:function(x,coords){
        	
        		let tempArray =[];
                for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)==x){
                   				tempArray.push(coords[ycounter].y);
                    	 }
                }
             return Math.max(...tempArray);
        	
        },
        getMaxYNotY:function(x,y,coords){
        	
        		let tempArray =[];
                for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)==x){
                		 		if (coords[ycounter].y != y){
                   					tempArray.push(coords[ycounter].y);
                   				}
                    	 }
                }
             return Math.max(...tempArray);
        	
        },
        getMinYNotY:function(x,y,coords){
        	
        		let tempArray =[];
                for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)==x){
                		 		if (coords[ycounter].y != y){
                   					tempArray.push(coords[ycounter].y);
                   				}
                    	 }
                }
             return Math.min(...tempArray);
        	
        },
        getNextX:function(x,y,coords){
        
        	
        	    for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)<x && (coords[ycounter].y==y)){
                   				return coords[ycounter].x;
                    	 }
                }
            
        	return null;
        	
        },
        getNextXRight:function(x,y,coords){
        	
        	    for(let ycounter=0;ycounter<coords.length;ycounter++){
        	    	
                		 if ((coords[ycounter].x)>x && (coords[ycounter].y==y)){
                   				return coords[ycounter].x;
                    	 }
                }
            
        	return null;
        	
        },
       
        getNextStepRight:function(x,y,coords){
        
                for(let ycounter=0;ycounter<coords.length;ycounter++){
                    
        
                        if ((coords[ycounter].x)>x && (coords[ycounter].y>y)){
                                    return [coords[ycounter].x,coords[ycounter].y];
                            }
                            
                    }
                
                return null;
                        
            
        },
        getNextStepLeft:function(x,y,coords){
      
      		for(let ycounter=0;ycounter<coords.length;ycounter++){
        	  	
      
      				 if ((coords[ycounter].x)==x && (coords[ycounter].y<y)){
                   				return [coords[ycounter].x,coords[ycounter].y];
                    	 }
                    	 
                 }
            
        	return null;
            	  	
       	
        },
        getNextStepRightDown:function(x,y,coords){
      
      		for(let ycounter=0;ycounter<coords.length;ycounter++){
        	  	
      
      				 if ((coords[ycounter].x)>x && (coords[ycounter].y<y)){
                   				return [coords[ycounter].x,coords[ycounter].y];
                    	 }
                    	 
                 }
            
        	return null;
            	  	
       	
        },
        getNextStepLeftUp:function(x,y,coords){
      
      
      		for(let ycounter=0;ycounter<coords.length;ycounter++){
        	  	
      
      				 if ((coords[ycounter].x)<x && (coords[ycounter].y==y)){
                   				return [coords[ycounter].x,coords[ycounter].y];
                    	 }
                    	 
                 }
      
      
      		for(let ycounter=0;ycounter<coords.length;ycounter++){
        	  	
      
      				 if ((coords[ycounter].x)<x && (coords[ycounter].y<y)){
                   				return [coords[ycounter].x,coords[ycounter].y];
                    	 }
                    	 
                 }
                 
                 
             	for(let ycounter=0;ycounter<coords.length;ycounter++){
        	  	
      
      				 if ((coords[ycounter].x)<x && (coords[ycounter].y>y)){
                   				return [coords[ycounter].x,coords[ycounter].y];
                    	 }
                    	 
                 }
          
            
        	return null;
            	  	
       	
        },
        getNextXLeft:function(x,y,coords){
        
        	    for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)<x && (coords[ycounter].y==y)){
                   				return coords[ycounter].x;
                    	 }
                }
            
        	return null;
        	
        },
      
        getNextXY:function(x,y,coords){
        	let tempReturn = [];
        	    for(let ycounter=0;ycounter<coords.length;ycounter++){
                		 if ((coords[ycounter].x)<x && (coords[ycounter].y<y)){
                   				return tempReturn[coords[ycounter].x,coords[ycounter].yY];
                    	 }
                }
            
        	return null;
        	
        },
        removeSinglePixel:function(value){
        	let lastone = value.toString().split('').pop();
        	if (lastone=="1" || lastone==1){
        		value=value -1;
        	}
        	
        	return value;
                
        },
        createSingleHzLine:function(X,coords,returnArray){
        	
        	
        	let tempY=this.getMinY(X,coords);
        	let xyArray=[];
        	returnArray.push(X);
        	returnArray.push(tempY);
        	
        	return;
        	let nextX=this.getNextXRight(X,tempY,coords );
        	if (nextX==null){
        		
        		xyArray=this.getNextStepRight(X,tempY,coords );
        			if (xyArray==null){
        				let nextY=this.getMaxY(X,coords);
       		 			returnArray.push(X);
        				returnArray.push(nextY);
        				
        			
      
        			}
        			else{
        	 			returnArray.push(X);
        	 			returnArray.push(xyArray[1]);
        	 			
        	 			
        				returnArray.push(xyArray[0]);
        	 			returnArray.push(xyArray[1]);
        	 			
        	 			
      
        			}
        			
        	}
        	
        		        	        
        },
        createSingleRHzLine:function(X,coords,returnArray){
        	
        	let tempY=this.getMaxY(X,coords);
        	let xyArray=[];
        	returnArray.push(X);
        	returnArray.push(tempY);
        	
        	return;
        	
       
        				

        	xyArray=this.getNextStepLeftUp(X,tempY,coords);
        	 	if (xyArray == null){
        				let nextY=this.getMinYNotY(X,tempY,coords);
       		 			returnArray.push(X);
        				returnArray.push(nextY);
              		}
        		else{
        	 			returnArray.push(X);
        	 			returnArray.push(xyArray[1]);
        				returnArray.push(xyArray[0]);
        	 			returnArray.push(xyArray[1]);
              		}
         },
        clone:function(obj) {
    		if (null == obj || "object" != typeof obj) return obj;
    		let copy = obj.constructor();
    		for (let attr in obj) {
        		if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    		}
    		return copy;
		},
        removeInternals:function(returnArray){
      	 	let point={x:0,y:0};
      	 	let xyCounter=[];
      	 	let count=0;
      	 	let xyPoints=[];
      	 	let rtArray=[];
      	 	let uXArray=[];
      	 	let internalBits=false;
      	 	
      	 	
      	 	 	for(let i=0;i<returnArray.length-1;i=i+2){
    		 	 	point.x=returnArray[i];
        			point.y=returnArray[i+1];
        			xyPoints.push(this.clone(point)); 	
        	 	}
        	 	
        	 	
       			for(let ii=0;ii<xyPoints.length;ii++){
       				count=0;
       				for(let iii=0;iii<xyPoints.length;iii++){
       				
       					if ((xyPoints[iii].x==xyPoints[ii].x) || (xyPoints[iii].y==xyPoints[ii].y)){
       							if (iii !=ii){
       								count++;	
       							}
       						}
       				}
       				
       				xyCounter[ii]=count;
       			}
  
  
       				
       			
       			let add=true;
       			
  
  
       			for(let z=0;z<xyPoints.length;z++){
       				if (xyCounter[z]>0){
       					add=true;
       					for(let l=0;l<rtArray.length;l++){
       						if ((xyPoints[z].x==rtArray[l].x) && (xyPoints[z].y==rtArray[l].y)){
       							add=false;	
       						}
       					}
       					if (add==true){
       						rtArray.push(this.clone(xyPoints[z]));
       					
       					}
       				}
       			}
       			
       			
       			
       		
       		
       			
       			returnArray=[];
       				returnArray.push(rtArray[0].x);
       				returnArray.push(rtArray[0].y);
       					for(let iii=1;iii<rtArray.length;iii++){
       						if ( (rtArray[iii].x==rtArray[iii-1].x || rtArray[iii].y==rtArray[iii-1].y) ){
       							if ( (rtArray[iii].x !=rtArray[iii-1].x || rtArray[iii].y!=rtArray[iii-1].y) ){
       								if ((returnArray[returnArray.length-2] ==rtArray[iii].x) || (returnArray[returnArray.length-1] ==rtArray[iii].y)){
       										returnArray.push(rtArray[iii].x);
     										returnArray.push(rtArray[iii].y);
     								}
     							}
     						}
       					}
       				returnArray.push(rtArray[0].x);
       				returnArray.push(rtArray[0].y);
       				
       				
       				
       			
        	return returnArray;
        	
        	
        },
        makeUniq:function(returnArray){
        	
        	let rtArray=[];
       
        	for(let i=0;i<returnArray.length;i=i+2){
        		
        		rtArray.push(Number(returnArray[i]) + "," + Number(returnArray[i+1]));
        	}
      
      		var unique;
      		let rt = unique = [...new Set(rtArray)];
        	
      	
        	  
        	  returnArray=[];
        	  
        	  for (let ii=0;ii<rt.length;ii++){
        	  	returnArray.push(Number(rt[ii].split(",")[0]));
        	  	returnArray.push(Number(rt[ii].split(",")[1]));
        	  }
        	  
        	  return returnArray;
        	  
        	
        },
        removeDiags:function(returnArray,coords){
        	
        		
        	let rtArray=[];
        	 	for(let i=2;i<(returnArray.length);i=i+2){
        
        			rtArray.push(returnArray[i-2]);
        			rtArray.push(returnArray[i-1]);
        	 	
        	 		
        	 				
        	 		if ((returnArray[i-2] != returnArray[i]) && (returnArray[i-1] != returnArray[i+1])){
        	 
        	 				for(let c=0;c<coords.length;c++){
                 		
                 				if (coords[c].y==returnArray[i+1] && returnArray[i-2]==coords[c].x){
             
             						
            	 					rtArray.push(returnArray[i-2]);
        	 						rtArray.push(returnArray[i+1]);
        	 						break;
        	
                 				}
                 				
                 				
                 				if (coords[c].y==returnArray[i-1] && returnArray[i]==coords[c].x){
             
             					        	 
                 			
            	 					rtArray.push(returnArray[i]);
        	 						rtArray.push(returnArray[i-1]);
        	 						break;
        	
                 				}
                			}
                 	
        	 		
        	 		}
        	 	
        	 		rtArray.push(returnArray[i]);
        	 		rtArray.push(returnArray[i+1]);
        	 		
        	 	}
        	 	
        	 		 	
       		//	rtArray.push(returnArray[returnArray.length-2]);
        	//	rtArray.push(returnArray[returnArray.length-1]);
     	 
        	
        	return rtArray;
        	
        },
        removeSequentialDuplicates:function(points){
        	let totalPoints = points.length;
        	let targetPoints = [];
        	let tPoints = [];
        	let xPoints=[];
        	/// HEREX
        	
        		const distinct = (value, index, self)=>{
                    	return self.indexOf(value) === index;
                 };
                 
        		
        		for(let i=0;i<points.length;i=i+2){
        				targetPoints.push(points[i] + "," + points[i+1]);
        		}
        		
        		
        		
        		targetPoints=targetPoints.filter(distinct);
        		
        		for(let ii=0;ii<targetPoints.length;ii++){
        			xPoints=targetPoints[ii].split(',')
        			tPoints.push(xPoints[0]);	
        			tPoints.push(xPoints[1]);	
        			
        		}
        		
        		
        		return tPoints;
        	
        },
        tranferObjectsToGeometricWindow:function(objectsInGroup)
        {
        	let polygons =[];
        	let polyPoints = [];
        	let actualPoints = [];
        	let bFound=false;
        	let childObjects = [];
        	let bigPolygon = [];
        	let fixedPolygon = [];
        	let successFul = [];
        	
        
        	// HERE replace processObjectsIntoPoints
        	
        	
        	
        	
          	for(let i=0;(i<objectsInGroup.length);i++){
          			if (typeof objectsInGroup[i]._objects !=='undefined'){
              					childObjects = objectsInGroup[i]._objects.forEach(function(childobj){
              							if (! childobj.type.toUpperCase().includes("TEXT") ){
              	    						polygons[i] = canvasApp.polyHelper.convertToGeometric(canvasApp.polyHelper.convert(childobj), objectsInGroup[i].left, objectsInGroup[i].top);
              	    							bigPolygon.push(polygons[i]);
              	    					
              	    					}
              	     			});
              	     		}
          	
          	}
          	
          			for(let pCounter=0;pCounter<polygons.length;pCounter++){
          				for(let ipoint=0;ipoint<polygons[pCounter].length;ipoint++){
          				
          					successFul.push(turf.point(polygons[pCounter][ipoint]));
          						
          					
          				}
          				
          			}
          			
          			let points = turf.featureCollection(successFul);
          
          			fixedPolygon = turf.convex(points);
          
        
          
        	
        },
        polyTransferObjectsToEditingWindow:function(targetCanvas,sourceCanvas)
        {
        	     let returnArray=[];
            	 let coords = [];
            	 let objectsInGroup = canvasApp.selectionHelper.getObjects();
            	 let pointArray = [];
            	 let pi=0;
            	 let temp =[];
            	 let bCount =false;
            	 let masterLeft=0;
            	 let masterTop=0;
            	 
            	 let masterLeftOffset=0;
            	 let masterTopOffset=0;
            	 objectsInGroup.sort((a, b) => {
					// First sort by `top` (vertical position)
					if (a.top === b.top) {
						// If `top` values are the same, sort by `left` (horizontal position)
						return a.left - b.left;
					}
					// Otherwise, sort by `top`
					return a.top - b.top;
				});
            	 
            	 
        		 let counter=0;
        		 
        		 let y=[];
        		 let x=[];
				 var minObject = objectsInGroup[0];
				 const delta = 0.5; // -duc- for Tolerance range
        		 	for(let ii=0;(ii<objectsInGroup.length);ii++){
						if(objectsInGroup[ii].left < minObject.left - delta){
							minObject = objectsInGroup[ii]
						}
						if(objectsInGroup[ii].top < minObject.top - delta){
							minObject = objectsInGroup[ii]
						}
        		 		
        		 		y.push(objectsInGroup[ii].top);
        		 		x.push(objectsInGroup[ii].left);
        		 		
        		 	}
        		 	
        		 	//masterLeftOffset=Math.min(...x);
        		 	//masterTopOffset=Math.min(...y);
					masterLeftOffset = minObject.left
					masterTopOffset = minObject.top
        		 	this.minObject = minObject
					var centerPoint = new fabric.Point(masterLeftOffset, masterTopOffset);
        		 	
        		 	for(let i=0;(i<objectsInGroup.length);i++){
        		 		
        		 		
						var objectOrigin = new fabric.Point(objectsInGroup[i].left, objectsInGroup[i].top);
						angle = minObject.angle
						var new_loc = fabric.util.rotatePoint(objectOrigin, centerPoint, angle*2*Math.PI/360*(-1))
						masterTop=new_loc.y  - Number(masterTopOffset);
						masterLeft=new_loc.x  - Number(masterLeftOffset);
              	 							
          				if (typeof objectsInGroup[i]._objects !=='undefined'){
								var angle = objectsInGroup[i].angle?objectsInGroup[i].angle:0
								
								var canvasCenter = new fabric.Point(sourceCanvas.getWidth()/2, sourceCanvas.getHeight()/2);

              					var childObjects = objectsInGroup[i]._objects.forEach(function(childobj){
              						
        
              							if (!childobj.type.toUpperCase().includes("TEXT")){
              						 		pointArray = [];
              								// if (typeof childobj.points !=='undefined' ){
              				
              								// 	for(pi=0;pi<childobj.points.length;pi++){
              								// 		masterLeft=0;
              	
              								// 		temp=childobj.points[pi];
              								// 		pointArray.push([Number(temp['x']) +  Number(masterLeft),Number(temp['y'])  + Number(masterTop)]);
              										
              								// 	}
              								
              								// 		pointArray.push(pointArray[0]);
              								// 		coords.push([pointArray]);
											// }
              								// else
											// {
              								// coords.push([[
											// 	    [Number(childobj.aCoords.tr.x) + Number(masterLeft), Number(childobj.aCoords.tr.y) +  Number(masterTop) ],
											// 	    [Number(childobj.aCoords.tl.x) + Number(masterLeft), Number(childobj.aCoords.tl.y)  +  Number(masterTop)],
											// 	   	[Number(childobj.aCoords.bl.x) + Number(masterLeft), Number(childobj.aCoords.bl.y)  +  Number(masterTop)],
											// 	    [Number(childobj.aCoords.br.x) + Number(masterLeft), Number(childobj.aCoords.br.y)  +  Number(masterTop)],
											// 		[Number(childobj.aCoords.tr.x) + Number(masterLeft), Number(childobj.aCoords.tr.y)  +  Number(masterTop)]
											// 		]]);
											// }	
											var points = childobj.points
											var pathOffset = childobj.pathOffset
											var paths = [];
											let basicPoint = points[0]
											for(var j = 0; j < points?.length; j++){      
												var point = points[j];
												if((point['x'] + point['y']) < (basicPoint['x'] + basicPoint['y'])){
													basicPoint = point
												}
											}

											for(var j = 0; j < points?.length; j++){
												var objectOrigin = false
												// if(points[0]['x'] == 0 ){
													objectOrigin = new fabric.Point((points[j]['x']) + Number(masterLeft), (points[j]['y']) +  Number(masterTop));
												// }
												// else{
													objectOrigin = new fabric.Point((points[j]['x'] - basicPoint['x']) + Number(masterLeft) + Number(childobj.left)+(pathOffset.x - basicPoint['x']), (points[j]['y'] - basicPoint['y']) +  Number(masterTop) + Number(childobj.top)+(pathOffset.y- basicPoint['y']));
												// }
												paths.push(
													[Math.round((objectOrigin.x)*10)/10, Math.round((objectOrigin.y)*10)/10 ]
												)
											}
											coords.push([paths]);
	          	    					}
              	     			});
              	     		}
          	
          			}
          			
          			let newPoly=null;
          	        let overlap1=[];		
          	        let overlap2=null;	
          	        let overlapping= null;
          	        let swapPoly = null;
          	        let uniqueObject = {}; 
          	        let bException = false;
          	        let ii=0;
          	        let lenArray= Math.round(coords.length/2);
          	        let iii=0;
          	        let poly1={};
          	    	let poly2={};
              	    
          	        let combined={};
          	        
          	        poly1.regions=coords[0];
          	        poly1.inverted =false;
          	        poly2.inverted =false;
          	        
					
          		    var segments = PolyBool.segments(poly1);
          		    
          		    	for (var i = 1; i < coords.length; i++){
  						  	poly2.regions=coords[i];
							var seg2 = PolyBool.segments(poly2);
  							var comb = PolyBool.combine(segments, seg2);
  							segments = PolyBool.selectUnion(comb);
							var polyTmp= PolyBool.polygon(segments);	
							if(polyTmp.regions.length > 1){
								return false
							}
						}
					
					poly1= PolyBool.polygon(segments);	
          	        poly2 = PolyBool.union(poly1, { regions: [], inverted: false });	
          						
          		
          		return poly2.regions[0];
          			
          		
        	
        },
        tranferObjectsToEditingWindow:function(targetCanvas,sourceCanvas)
	    {
	    	// THIS IS THE LATEST 
	    	return this.polyTransferObjectsToEditingWindow(targetCanvas,sourceCanvas);
	    	
                // Correct function 
                 let returnArray=[];
                 let coords = [];
                 let objectsInGroup = canvasApp.selectionHelper.getObjects();
                var f
               	    
                
                 // L shape combine
                 let bNotStraightLine = false;
                 let childObjects = null;
                 let counter=0;
                 let targetPoints = [];
                 let lastX=0;
                 let lastY=0;
                 let tempXYArray=[];
                 let tempPOS=null;
                 let tempY=null;
                 let lastYLoop=null;
                 
                 //STEP 1
                 
                 let maxWidth=0;
                 let maxHeight=0;
                 
                 	for(let i=0;(i<objectsInGroup.length);i++){
          				if (typeof objectsInGroup[i]._objects !=='undefined'){
              					childObjects = objectsInGroup[i]._objects.forEach(function(childobj){
              						
              						
              							if (! childobj.type.toUpperCase().includes("TEXT") ){
              							
              							
              								maxHeight=maxHeight+childobj.get('height')/heightResize;
              								maxWidth=maxWidth+childobj.get('width')/widthResize;
              								
              								canvasApp.combineHelper.maxHeight=maxHeight;
              								canvasApp.combineHelper.maxWidth=maxWidth;
              								
              								
              	
              	    					}
              	     			});
              	     		}
          	
          			}
                 
               
                
       
                 this.tranferObjectsToGeometricWindow(objectsInGroup);
                
                
                	coords=this.processObjectsIntoPoints(objectsInGroup);
        			let xArray=this.getSegment(coords,"x");
        			let yArray=this.getSegment(coords,"y");
        			let minX=Math.min(...xArray); 
                 	let maxX=Math.max(...xArray);
                 	let minY=Math.min(...yArray); 
                 	let maxY=Math.max(...yArray);
                 	
                 	
                 	let modDifferenceX=(maxX-minX) % 10;
                 	let modSupposedToBeX = canvasApp.combineHelper.maxWidth % 10;
                 	let modDifferenceY=(maxY-minY) % 10;
                 	let modSupposedToBeY = canvasApp.combineHelper.maxHeight % 10;
                 	
                 	if (modDifferenceY==modSupposedToBeY){
                 		modDifferenceY=0;
                 	}
                 	if (modDifferenceX==modSupposedToBeX){
                 		modDifferenceX=0;
                 	}
                 	
                 	lastY=maxY-minY;
                 	
                	    
                   
                    
                 	xArray=this.getAllCoordsSorted(xArray,minX);
                 	yArray=this.getAllCoordsSorted(yArray,minY);
                 
                	for(let c=0;c<coords.length;c++){
                 		
                		coords[c].y=coords[c].y-minY;
                		coords[c].x=coords[c].x-minX;
                 		coords[c].y=this.removeSinglePixel(coords[c].y);
                 		coords[c].x=this.removeSinglePixel(coords[c].x);
                 	}
                 	
                 
                 
                 	
                    coords = Array.from(new Set(coords.map(JSON.stringify))).map(JSON.parse);
                    
                  	for(let iii=0;iii<xArray.length;iii++){
               		
                   		this.createSingleHzLine(xArray[iii],coords,returnArray);
                   		
                   		
                    }
                    
                   xArray.sort(function(a, b){return b-a});
                 
                    
                    for(let i=0;i<xArray.length;i++){
                    	
                      	this.createSingleRHzLine(xArray[i],coords,returnArray);
               
               	    }
             		
             		//returnArray=this.makeUniq(returnArray);      
             		
             		
             	
             
                            
                  returnArray=this.removeDiags(returnArray,coords);
                  
                  
                  for (var ii=0;ii<returnArray.length-1;ii=ii+2){
                  	  	
                  	if (returnArray[ii] %10 ==modDifferenceX ){
                  		returnArray[ii]=returnArray[ii]-modDifferenceX;
                  	}
                  	
                  	if (returnArray[ii+1] %10 ==modDifferenceY ){
                  		returnArray[ii+1]=returnArray[ii+1]-modDifferenceY;
                  	}
                  	
                  }
                
                
                //	returnArray=this.makeUniq(returnArray);       
                	
                	
                  //	returnArray=this.removeInternals(returnArray);
            
                 
                 // returnArray=this.removeSequentialDuplicates(returnArray);
                 
                 let newWidth=Math.round(maxX-minX);
                 let newHeight=Math.round(maxY-minY);
                 newWidth=canvasApp.combineHelper.removeSinglePixel(newWidth);
                 newHeight=canvasApp.combineHelper.removeSinglePixel(newHeight);
                    		
                    let mArray=[0,0,newWidth,newHeight];
                    
                    returnArray.unshift(mArray);
                   
                 
              
                    if (bNotStraightLine ==true ){
                    	
                    //	 return this.tranferPolygonObjectsToEditingWindow(targetCanvas,sourceCanvas,returnArray);
                    }
                	
                return returnArray;
            },
        buildItemsFromApoints:function(aPoints,canvasToAdd,newBoothNumber){
		
            // if (typeof newBoothNumber === 'undefined' || newBoothNumber.length==0){
            //     newBoothNumber =String(canvasApp.safetyHelper.getObjectNumber());
            // }
            
            aPoints[2]=canvasApp.combineHelper.removeSinglePixel(aPoints[2]);
            aPoints[3]=canvasApp.combineHelper.removeSinglePixel(aPoints[3]);
		
	       let imageObject	= new fabric.Rect({
    				width: aPoints[2],
        			height: aPoints[3],
    				fill: canvasApp.colorHelper.get('available'),
    				stroke: canvasApp.colorHelper.font('border'),
    				relativex: aPoints[0],
    				relativey: aPoints[1],
    	    		strokeWidth: 1,
    	    		sub_type: 1,
            		selectable:false,
            		hoverCursor: 'pointer'
            		});
            		
            let groupObject =   new fabric.Group([imageObject],{
    				top: aPoints[1],
    				left:  aPoints[0], 
    				width: aPoints[2],
        		   	height: aPoints[3],
    				fill: canvasApp.colorHelper.get('available'),
    				stroke: canvasApp.colorHelper.get('border'),
                		strokeWidth: 1,
	            		selectable:false,
	            		hasControls:false,
	            		id: 'combined'	
	          	});
	          	
	          				
		    /// HERE for objectNUmber
            let textObject= new fabric.IText(newBoothNumber, {
                    fontSize: fontSize,
                    originX: 'center',
                    originY: 'center',
                    textAlign: 'center',
                    left: aPoints[2]/2,
                    top: aPoints[3]/2
            });
    		 
			 let zoomLevelW=300/aPoints[2];
			 let zoomLevelH=300/aPoints[3];
			 
			 let zoomLevel =1;
			 zoomLevel=zoomLevelW;
		
			 
			 if (zoomLevelW>zoomLevelH){
			 	zoomLevel=zoomLevelH;
			 }
			 
			 
			 canvasToAdd.add(groupObject);
		 	 canvasToAdd.add(textObject);
		 
	    	canvasToAdd.setZoom(zoomLevel);
	        canvasToAdd.setWidth((aPoints[2]+1)*zoomLevel);
	    	canvasToAdd.setHeight((aPoints[3]+1)*zoomLevel);
	    	canvasToAdd.renderAll();
	    	 
	    	 let combinedWidth=Math.trunc(aPoints[2]/widthResize);
	    	 let combinedHeight=Math.trunc(aPoints[3]/heightResize);
	    	 
	    	 	combinedWidth=canvasApp.combineHelper.removeSinglePixel(Math.trunc(combinedWidth));
				combinedHeight=canvasApp.combineHelper.removeSinglePixel(Math.trunc(combinedHeight));
		
			
				//j('#combinedWidth').val(combinedWidth);
				//j('#combinedHeight').val(combinedHeight);
			
		
		},
		isPolygon:function(points){
			let ul=null;
			let lr=null;
			let bIsPolyGon=false;
            let loopObj =null    
      			for (let i=0;i<points.length;i++){
            		loopObj=points[i];
            			if (ul==null || lr==null){
                    			ul=loopObj;
                    			lr=loopObj;
  	            		}
    		            if (loopObj.x<ul.x && loopObj.y<ul.y){
            			        ul=loopObj;
                  		}
                  		if (loopObj.x>lr.x && loopObj.y>lr.y){
                    			lr=loopObj;
                  		}
    		  	}
        		for (let ii=0;ii<points.length;ii++){
            			loopObj=points[ii];
                  			if (loopObj.x != ul.x && loopObj.y != ul.y){
                    			if (loopObj.x !=lr.x && loopObj.y != lr.y){
                     				 bIsPolyGon=true;
                    		}
                  		}
      			}
      			
      		return bIsPolyGon;		
			
		},
		convertToRect:function(points){
			let ul=null;
			let ur=null;
			let ll=null;
			let lr=null;
			let loopObj=null;
			let xyArray=[];
			let height =0;
			let width =0;
			

			      for (let i=0;i<points.length;i++){
            			loopObj=points[i];
            			if (ul==null || ur==null || ll==null || lr==null){
                    			ul=loopObj;
                    			ur=loopObj;
                    			ll=loopObj;
                    			lr=loopObj;
              			}
                 		if (loopObj.x<ul.x && loopObj.y<ul.y){
                    			ul=loopObj;
                  		}
                  		if (loopObj.x>lr.x && loopObj.y>lr.y){
                    			lr=loopObj;
                  		}
    
      			}
        		for (let ii=0;ii<points.length;ii++){
            			loopObj=points[ii];
                  		if (loopObj.x>ur.x && loopObj.y==ul.y){
                    		ur=loopObj;
                  		}
                  		if (loopObj.x==ul.x && loopObj.y>ll.y){
                    		ll=loopObj;
                  		}
    
      			}

				height=ll.y-ul.y;
				width=ur.x-ul.x;
				
				xyArray.push(height);
				xyArray.push(width);
				
				return xyArray;
				
		},
	    process:function(){
	    	let combinedBoothNumber="";
	    	let blnAdd =true;	
	      	let objectsInGroup = combineCanvas.getObjects();
	      	let points = [];
	      	let childObjects = [];
	      
	     		
	    	let listBooths=" " + //j('#modalCombineinBoothNumber').html() + " ";
              	     objectsInGroup.forEach(function(object) {
              	     		if (typeof object.text !=='undefined'){
              					combinedBoothNumber=object.text;
              				}
              				if (typeof object.points !=='undefined'){
              					points = object.points;
              				}
              				if (typeof object._objects !=='undefined'){
              					childObjects = object._objects.forEach(function(childobj){
              	     				if (typeof childobj.points !=='undefined'){
              	     					points=childobj.points;
              	     				}
              	     			});
              	     		}
                    });
                    
                    
                    
                    
                    if (combinedBoothNumber.length==0){
                    			
        					//  canvasApp.uHelper.alertBox(' Booth Number is Required','Error','error');
        	 			
                    	return false;
                    }
                    if (listBooths.indexOf(" " + combinedBoothNumber + " ")==-1){
                   		let newcombinedBoothNumber="" //canvasApp.safetyHelper.addObjectNumber(combinedBoothNumber); duc
                   		if (combinedBoothNumber != newcombinedBoothNumber){
                   					
        						//  canvasApp.uHelper.alertBox(combinedBoothNumber  + '  Booth Number is Duplicate New is ' +newcombinedBoothNumber,'Error','error');
        	 				
        	 				// canvasApp.safetyHelper.changeMade();
                   	
                   		}
                   		combinedBoothNumber=newcombinedBoothNumber;
                   		blnAdd =false;
                   }
                    
                   
                    
                    ///Here 
                    var activeGroup = canvasApp.helperCanvas.getActiveObject(); 
             		objectsInGroup = activeGroup.getObjects();
             		let fill=canvasApp.colorHelper.get('available');
              		let status="available";
             		let angle = activeGroup.get('angle');
             		let booth_keys="";
              	    objectsInGroup.forEach(function(object) {
              	    	
              	    		if (typeof object.get('id') !=='undefined' && object.get('id').substr(0,3) !='tb_'){
              	    					if (booth_keys.indexOf(object.get('id')) ==-1){
              	    						booth_keys = booth_keys + " " + object.get('id');
              	    					}
              	    		}
              	    		if (typeof object._objects !=='undefined'){
              	   				object._objects.forEach(function(obj){
              	    				if (obj.type=='rect' || obj.type=='polygon'){
              	   	 					if (typeof obj.get('fill') !=='undefined'){
              	    						fill = obj.get('fill');
              	    					}
              	    				}
              	    				if (typeof obj.get('angle') !=='undefined' && obj.get('angle') != 0){
              	    					angle = obj.get('angle');
              	    				}
              	    				
              	    				if (typeof obj.get('id') !=='undefined' && obj.get('id').substr(0,3) !='tb_' ){
              	    					if (booth_keys.indexOf(obj.get('id')) ==-1){
              	    						booth_keys = booth_keys + " " + obj.get('id');
              	    					}
              	    				}	
              	    			});
              	    		}
              				canvasApp.helperCanvas.remove(object);
                    });
                    canvasApp.helperCanvas.discardActiveObject();
                    
                    
                    
                    // canvasApp.deleteHelper.deleteObjects(j('#modalCombineinBoothNumber').html(),booth_keys); duc
                    if (blnAdd==true){
                   		//  canvasApp.safetyHelper.addObjectNumber(combinedBoothNumber); // duc
                    }
                	let uuid=canvasApp.tbHelper.uuid();
                	
                 	let newBooth=null;
                 	
                 	let newBoothId = "booth" + uuid;	
                 	
                 	status=	canvasApp.combineHelper.status;
                 	
                 	if (status==""){
                 		status="available";
                 	}
                 	
                              	                	
                	if (this.isPolygon(points)==true){
						//
               			// newBooth=canvasApp.uHelper.addPolyBooth(newBoothId,
                		// points,
                		// Number(j('#combinedWidth').val())*widthResize,
                		// Number(j('#combinedHeight').val())*heightResize,
         		   		// canvasApp.selectionHelper.top,canvasApp.selectionHelper.left,
         		   		// canvasApp.combineHelper.fill_color,
         		   		// canvasApp.colorHelper.get('border'),
         		   		// uuid,combinedBoothNumber,2,angle,canvasApp.combineHelper.status,
         		   		// booth_keys);
         		   	
         		   }
         		   else{
						//
         		   		// points = this.convertToRect(points);
              			// newBooth=canvasApp.uHelper.addBooth(newBoothId,
         		  		// Number(j('#combinedWidth').val())*widthResize,Number(j('#combinedHeight').val())*heightResize,
         		  		// canvasApp.selectionHelper.top,canvasApp.selectionHelper.left,
         		  		// canvasApp.combineHelper.fill_color,
         		   		// canvasApp.colorHelper.get('border'),
         		   		// uuid,combinedBoothNumber,2,angle,canvasApp.combineHelper.status,booth_keys);
         		   	
         		   }
         		     newBooth.set({parent_key:canvasApp.combineHelper.parent_key,company_name:canvasApp.combineHelper.company_name,company_key:canvasApp.combineHelper.company_key,status:canvasApp.combineHelper.status,booth_group:canvasApp.combineHelper.booth_group});
	        		 canvasApp.combineHelper.ids="";
	    	    	//  canvasApp.mHelper.hideModal(); duc
	    	    	 
	    	    	 newBoothId="booth"+newBooth.get('id');
	    	    	 
	    	    	 /// KLYDE
	    	    	 	if (this.lcombinedList.length<36){
								return;
						}
							    	    	 
	    	    	 let boothJSON={};
	    	    	 let mapSpec={};
	    	    	 let deleteKeys=['opacity','visible','selectable','visible','aCoords'];
						mapSpec["offsetY"]=offsetY;
						mapSpec["offsetX"]=offsetX;
						mapSpec["heightresize"]=heightresize;
						mapSpec["widthresize"]=widthresize;
						
						boothJSON[newBoothId] ={};
						//
	    	    	 	// Object.keys(canvasObjects[1][newBoothId]).forEach(subkey =>{
						// 		boothJSON[newBoothId][subkey] = {};
						// 		boothJSON[newBoothId][subkey]=canvasApp.uHelper.cloneObject(canvasObjects[1][newBoothId][subkey]);
						// 		boothJSON[newBoothId][subkey]=canvasApp.uHelper.cleanBooth(deleteKeys,boothJSON[newBoothId][subkey],newBoothId,subkey);
						// });
						
						//
						// //Shani:Modified:06/15/2021 - C46845 - Combine Issue		
	    	  			//  let dataToSave = { booth_number: newBooth.get('booth_number'), width: Number(//j('#combinedWidth').val()),height: Number(//j('#combinedHeight').val()) ,spec: JSON.stringify(mapSpec), company_key:canvasApp.combineHelper.company_key, combine2: JSON.stringify(boothJSON), combine_list : this.lcombinedList, map_key: map_key };
	    	  		 	// //let dataToSave = { booth_number: newBooth.get('booth_number'), width: Number(//j('#combinedWidth').val()),height: Number(//j('#combinedHeight').val()) ,spec: JSON.stringify(mapSpec), company_key:canvasApp.combineHelper.company_key, combine2: JSON.stringify(boothJSON), combine_list : this.lcombinedList };
						// dataToSave.type = 'application/x-www-form-urlencoded';
						// canvasApp.dbHelper.saveData(map_key,"combine",canvasApp.generalHelper.saveComplete,dataToSave);
     				
     					// // delete boothJSON; //
     				
     					// this.lcombinedList="";
     					
     				canvasApp.selectionHelper.create();


        }
    });
          


    canvasApp.polyHelper= new Object({
        rotate:function(cx, cy, x, y, angle) {
                let radians = (Math.PI / 180) * angle,
                cos = Math.cos(radians),
                   sin = Math.sin(radians),
                nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
                ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
                return [nx, ny];
        },
        getAreaIntersects:function(x,y,width,height,x2,y2,width2,height2){

            const a1=new Point2D(x,y);
            const a2=new Point2D(x+width,y+height);
            
            const b1=new Point2D(x2,y2);
            const b2=new Point2D(x2+width2,y2+height2);
            
            const int=Intersection.intersectRectangleRectangle(a1, a2, b1, b2) ;
            let newPoints=[];
            let X=[];
            let Y=[];
            for(let i=0;i<int.points.length;i++){
                    Y.push(int.points[i].y);
                    X.push(int.points[i].x);
            }
            
            const maxX=Math.max(...X);
            const maxY=Math.max(...Y);
            const minX=Math.min(...X);
            const minY=Math.min(...Y);
            
            newPoints.push([minX,minY]);
            newPoints.push([maxX,minY]);
            newPoints.push([maxX,maxY]);
            newPoints.push([minX,maxY]);
            newPoints.push([minX,minY]);
            
            let vint = geometric.polygonArea(newPoints);
            
            return vint;
            
        },
        convertToGeometric:function(obj,left,top){
            
            let returnArray=[];
            let pushArray=[];
            
            if (obj.length==1){
                obj = obj.pop(0);
            }
            
            for(let counter=0;(counter<obj.length);counter++){
                pushArray=[];
                if (typeof obj[counter].x !== undefined ){
                    
                    pushArray.push(obj[counter].x +left);
                    pushArray.push(obj[counter].y+top); //
                    
                }
                else{
                    
                    
                    pushArray.push(obj[counter][0] +left);
                    pushArray.push(obj[counter][1] +top);
                }
                    
                 returnArray.push(pushArray);
            }
            
            return returnArray;		
        },
        angle:function(obj,left,top){
            let points = this.convertToGeometric(obj,left,top);
            let nextI = 0;
            let line =[];
            let maxAngle=0;
            let angle =0;
            let pointsArray = [];
                for(let ii=0;ii<points.length-1;ii++){
                    pointsArray.push(points[ii],points[ii+1]);	
                }
                for(let iii=points.length;iii<1;iii=iii-1){
                    pointsArray.push(points[iii],points[iii+1]);	
                }
            
            
                for(let i=0;i<pointsArray.length-1;i++){
                    nextI=i+1;
                    line=[];
                    if (nextI>pointsArray.length){
                        nextI=nextI-pointsArray.length;
                    }
                    line.push(pointsArray[i]);
                    line.push(pointsArray[nextI]);
                    
                        maxAngle=geometric.lineAngle(line);
                        if (Math.abs(maxAngle)>Math.abs(angle)){
                            
                            angle=maxAngle;
                        }
                
                }
            
            return Math.abs(90- Math.abs(angle));
            
        },
        convertToPoints:function(obj){
                return [[[obj.tl.x,obj.tl.y],
                [obj.tr.x,obj.tr.y],
                [obj.br.x,obj.br.y],
                [obj.bl.x,obj.bl.y],
                [obj.tl.x,obj.tl.y]]];
            
            
        },
        getWidthHeightDifference:function(aObj){
            let garbage=aObj.pop();
            let x=[];
            let y=[];
            for (let xy=0;xy<aObj.length;xy++){
                x.push(aObj[xy][0]);				
                y.push(aObj[xy][1]);				
                
            }
            let maxX = Math.max(...x) - Math.min(...x);
            let maxY = Math.max(...y) - Math.min(...y);
            if (isNaN(maxX) || isNaN(maxY)){
                return null;
            }
            return [maxX,maxY];
        },
        convert:function(obj){
                if (typeof obj.points !=='undefined'){
                        return obj.points;
                    }
        
                return [obj.aCoords.tl,obj.aCoords.tr,obj.aCoords.br,obj.aCoords.bl]; 
        },
        intersect:function(fig1, fig2) {
          var fig2a = this.alignPolygon(fig2, fig1);
          if (!this.checkPolygons(fig1, fig2a)) {
            return false;
          }
          let edges = this.edgify(fig1, fig2a);
          let polygons = this.polygonate(edges);
          let filteredPolygons = this.filterPolygons(polygons, fig1, fig2a, "intersect");
          return filteredPolygons;
        },

        alignPolygon:function(polygon, points) {
          for (let i = 0; i < polygon.length; i++) {
            for (let j = 0; j < points.length; j++) {
              if (this.distance(polygon[i], points[j]) < 0.00000001)
              polygon[i] = points[j];
            }    
          }
          return polygon;
        },

        distance:function(p1, p2) {
          let dx = Math.abs(p1.x - p2.x);
          let dy = Math.abs(p1.y - p2.y);
          return Math.sqrt(dx*dx + dy*dy);
        },

        checkPolygons:function(fig1, fig2) {
          let figs = [fig1, fig2];
          for (let i = 0; i < figs.length; i++) {
            if (figs[i].length < 3) {
              return false; 
            } 
          }
          return true;  
        },

        edgify:function(fig1, fig2) {
          //create primary array from all edges
          let primEdges = this.getEdges(fig1).concat(this.getEdges(fig2));
          let secEdges = [];  
          //check every edge
          for(let i = 0; i < primEdges.length; i++) {
            let points = [];
            //for intersection with every edge except itself
            for(let j = 0; j < primEdges.length; j++) {
              if (i != j) {
                let interPoints = this.findEdgeIntersection(primEdges[i], primEdges[j]);
                this.addNewPoints(interPoints, points);        
              }
            }
            //add start and end points to intersection points
            var startPoint = primEdges[i][0];
            startPoint.t = 0;
            var endPoint = primEdges[i][1];
            endPoint.t = 1;
            this.addNewPoints([startPoint, endPoint], points);
            //sort all points by position on edge
            points = this.sortPoints(points);
            //break edge to parts
            for (let k = 0; k < points.length - 1; k++) {
              let edge = [
                { x: points[k].x, y: points[k].y },
                { x: points[k+1].x, y: points[k+1].y}
              ];
              // check for existanse in sec.array
              if (!this.edgeExists(edge, secEdges)) {
                //push if not exists
                secEdges.push(edge);
              }          
            }    
          }  
          return secEdges;
        },

         addNewPoints:function(newPoints, points) {
          if (newPoints.length > 0) {
            //check for uniqueness
            for (let k = 0; k < newPoints.length; k++) {      
              if (!this.pointExists(newPoints[k], points)) {        
                points.push(newPoints[k]);
              }
            }                   
          }   
        },

        sortPoints:function(points) {
          let p = points;
          p.sort((a,b) => {
                if (a.t > b.t) return 1;
                if (a.t < b.t) return -1;
              });
          return p;
        },

        getEdges:function(fig) {
          let edges = [];
          let len = fig.length;
          for (let i = 0; i < len; i++) {
            edges.push([
              {x: fig[(i % len)].x, y: fig[(i % len)].y},
              {x: fig[((i+1) % len)].x, y: fig[((i+1) % len)].y}
            ]);
          }
          return edges;
        },
        findEdgeIntersection:function(edge1, edge2) {
          let x1 = edge1[0].x;
          let x2 = edge1[1].x;
          let x3 = edge2[0].x;
          let x4 = edge2[1].x;
          let y1 = edge1[0].y;
          let y2 = edge1[1].y;
          let y3 = edge2[0].y;
          let y4 = edge2[1].y;
          let nom1 = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
          let nom2 = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
          let denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
          let t1 = nom1 / denom;
          let t2 = nom2 / denom;
          let interPoints = [];
          //1. lines are parallel or edges don't intersect 
          if (((denom === 0) && (nom1 !== 0)) || (t1 <= 0) || (t1 >= 1) || (t2 < 0 ) || (t2 > 1)) {
            return interPoints;   
          }
          //2. lines are collinear 
          else if ((nom1 === 0) && (denom === 0)) {
            //check if endpoints of edge2 lies on edge1
            for (let i = 0; i < 2; i++) {
              let classify = this.classifyPoint(edge2[i], edge1);
              //find position of this endpoints relatively to edge1
              if (classify.loc == "ORIGIN" || classify.loc == "DESTINATION") {
                interPoints.push({x: edge2[i].x, y: edge2[i].y, t: classify.t});
              }
              else if (classify.loc == "BETWEEN") {
                var x = +((x1 + classify.t*(x2 - x1)).toPrecision(10));
                var y = +((y1 + classify.t*(y2 - y1)).toPrecision(10));
                interPoints.push({x: x, y: y, t: classify.t});
              }
            }    
            return interPoints; 
          }
          //3. edges intersect
          else {
            for (let i = 0; i < 2; i++) {
              let classify = this.classifyPoint(edge2[i], edge1);
              if (classify.loc == "ORIGIN" || classify.loc == "DESTINATION") {
                interPoints.push({x: edge2[i].x, y: edge2[i].y, t: classify.t});
              }
            }
            if (interPoints.length > 0) {
              return interPoints;  
            }
            let x = +((x1 + t1*(x2 - x1)).toPrecision(10));
            let y = +((y1 + t1*(y2 - y1)).toPrecision(10));
            interPoints.push({x: x, y: y, t: t1});
            return interPoints;
          }
          return interPoints;
        },

        classifyPoint:function(p, edge) {
          let ax = edge[1].x - edge[0].x;
          let ay = edge[1].y - edge[0].y;
          let bx = p.x - edge[0].x;
          let by = p.y - edge[0].y;
          let sa = ax * by - bx * ay;
          if ((p.x === edge[0].x) && (p.y === edge[0].y)) {
            return {loc: "ORIGIN", t: 0};
          }
          if ((p.x === edge[1].x) && (p.y === edge[1].y)) {
            return {loc: "DESTINATION", t: 1};
          }
          let theta = (this.polarAngle([edge[1], edge[0]]) - 
            this.polarAngle([{x: edge[1].x, y: edge[1].y}, {x: p.x, y: p.y}])) % 360;
          if (theta < 0) {
            theta = theta + 360;
          } 
          if (sa < -0.0000000001) {    
            return {loc: "LEFT", theta: theta};
          }
          if (sa > 0.00000000001) {    
            return {loc: "RIGHT", theta: theta};
          }
          if (((ax * bx) < 0) || ((ay * by) < 0)) {
            return {loc: "BEHIND", theta: 0};
          }
          if ((Math.sqrt(ax * ax + ay * ay)) < (Math.sqrt(bx * bx + by * by))) {
            return {loc: "BEYOND", theta: 180};
          }
          let t;
          if (ax !== 0) {
            t = bx/ax;
          } else {
            t = by/ay;
          }
          return {loc: "BETWEEN", t: t};
        },

        polarAngle:function(edge) {
          let dx = edge[1].x - edge[0].x;
          let dy = edge[1].y - edge[0].y;
          if ((dx === 0) && (dy === 0)) {
            return false;
          }
          if (dx === 0) {
            return ((dy > 0) ? 90 : 270);
          }
          if (dy === 0) {
            return ((dx > 0) ? 0 : 180);
          }
          let theta = Math.atan(dy/dx)*360/(2*Math.PI);
          if (dx > 0) {
            return ((dy >= 0) ? theta : theta + 360);
          } else {
            return (theta + 180);
          }
        },
         
        pointExists:function(p, points) {
          if (points.length === 0) {
            return false;
          }
          for (let i = 0; i < points.length; i++) {
            if ((p.x === points[i].x) && (p.y === points[i].y)) {
              return true;
            }
          }
          return false;
        },

        edgeExists:function(e, edges) {
          if (edges.length === 0) {
            return false;
          }
          for (let i = 0; i < edges.length; i++) {
            if (this.equalEdges(e, edges[i]))
              return true;
          }
          return false;  
        },

        equalEdges:function(edge1, edge2) {
          if (((edge1[0].x === edge2[0].x) &&
              (edge1[0].y === edge2[0].y) &&
              (edge1[1].x === edge2[1].x) &&
              (edge1[1].y === edge2[1].y)) || (
              (edge1[0].x === edge2[1].x) &&
              (edge1[0].y === edge2[1].y) &&
              (edge1[1].x === edge2[0].x) &&
              (edge1[1].y === edge2[0].y))) {
            return true;
          } else {
            return false;
          }
        },
         
        polygonate:function(edges) {
          let polygons = [];
          let polygon = [];
          let len = edges.length;
          let midpoints = this.getMidpoints(edges);
          //start from every edge and create non-selfintersecting polygons
          for (let i = 0; i < len - 2; i++) {
            let org = {x: edges[i][0].x, y: edges[i][0].y};    
            let dest = {x: edges[i][1].x, y: edges[i][1].y};
            let currentEdge = i;
            let point;
            let p;
            let direction;
            let stop;
            //while we havn't come to the starting edge again
            for (direction = 0; direction < 2; direction++) {
              polygon = [];
              stop = false;
              while ((polygon.length === 0) || (!stop)) {
              //add point to polygon
                polygon.push({x: org.x, y: org.y});
                point = undefined;
                //look for edge connected with end of current edge
                for (let j = 0; j < len; j++) {
                  p = undefined;
                  //except itself
                  if (!this.equalEdges(edges[j], edges[currentEdge])) {
                    //if some edge is connected to current edge in one endpoint
                    if ((edges[j][0].x === dest.x) && (edges[j][0].y === dest.y)) {
                      p = edges[j][1];
                    }
                    if ((edges[j][1].x === dest.x) && (edges[j][1].y === dest.y)) {
                      p = edges[j][0];
                    }
                    //compare it with last found connected edge for minimum angle between itself and current edge 
                    if (p) {
                      let classify = this.classifyPoint(p, [org, dest]);
                      //if this edge has smaller theta then last found edge update data of next edge of polygon
                      if (!point || 
                          ((classify.theta < point.theta) && (direction === 0)) ||
                          ((classify.theta > point.theta) && (direction === 1))) {
                        point = {x: p.x, y: p.y, theta: classify.theta, edge: j};
                      }
                    }
                  }
                }
                //change current edge to next edge
                org.x = dest.x;
                org.y = dest.y;
                dest.x = point.x;
                dest.y = point.y;
                currentEdge = point.edge;
                //if we reach start edge
                if ((org.x == edges[i][0].x) &&
                    (org.y == edges[i][0].y) &&
                    (dest.x == edges[i][1].x) &&
                    (dest.y == edges[i][1].y)) {
                  stop = true;
                  //check polygon for correctness
                  /*for (let k = 0; k < allPoints.length; k++) {
                    //if some point is inside polygon it is incorrect
                    if ((!this.pointExists(allPoints[k], polygon)) && (this.findPointInsidePolygon(allPoints[k], polygon))) {
                      polygon = false;
                    }
                  }*/
                  for (var k = 0; k < midpoints.length; k++) {
                    //if some midpoint is inside polygon (edge inside polygon) it is incorrect
                    if (this.findPointInsidePolygon(midpoints[k], polygon)) {
                      polygon = false;
                    }
                  }
                }   
              }
              //add created polygon if it is correct and was not found before
              if (polygon && !this.polygonExists(polygon, polygons)) {
                polygons.push(polygon);
              }
            }    
          }
          return polygons;
        },

        polygonExists:function(polygon, polygons) {
          //if array is empty element doesn't exist in it
          if (polygons.length === 0) return false;
          //check every polygon in array
          for (let i = 0; i < polygons.length; i++) {
            //if lengths are not same go to next element
            if (polygon.length !== polygons[i].length) continue;
            //if length are same need to check
            else {
              //if all the points are same
              for (let j = 0; j < polygon.length; j++) {
                //if point is not found break forloop and go to next element
                if (!this.pointExists(polygon[j], polygons[i])) break;
                //if point found
                else {
                  //and it is last point in polygon we found polygon in array!
                  if (j === polygon.length - 1) return true;
                }        
              }
            }
          }
          return false;
        },

        filterPolygons:function(polygons, fig1, fig2, mode) {
          let filtered = [];
          let c1, c2;
          let point;
          let bigPolygons = this.removeSmallPolygons(polygons, 0.0001);
          for(let i = 0; i < bigPolygons.length; i++) {
            point = this.getPointInsidePolygon(bigPolygons[i]);
            c1 = this.findPointInsidePolygon(point, fig1);
            c2 = this.findPointInsidePolygon(point, fig2);
            if (
                ((mode === "intersect") && c1 && c2) || //intersection
                ((mode === "cut1") && c1 && !c2) ||     //fig1 - fig2
                ((mode === "cut2") && !c1 && c2) ||     //fig2 - fig2
                ((mode === "sum") && (c1 || c2))) {     //fig1 + fig2      
              filtered.push(bigPolygons[i]);
            }
          }
          return filtered;
        },

        removeSmallPolygons:function(polygons, minSize) {
          let big = [];
          for (let i = 0; i < polygons.length; i++) {
            if (this.polygonArea(polygons[i]) >= minSize) {
              big.push(polygons[i]);
            }
          }
          return big;
        },

        polygonArea:function(p) {
          let len = p.length;
          let s = 0;
          for (let i = 0; i < len; i++) {
             s += Math.abs((p[i % len].x * p[(i + 1) % len].y) - (p[i % len].y * 
              p[(i + 1) % len].x));
          }
          return s/2;
        },

        getPointInsidePolygon:function(polygon) {
          let point;
          let size = this.getSize(polygon);
          let edges = this.getEdges(polygon);
          let y = size.y.min + (size.y.max - size.y.min) / Math.PI;
          let dy = (size.y.max - size.y.min) / 13;
          let line = [];
          let points;
          let interPoints = [];
          let pointsOK = false;
          while (!pointsOK) {
            line = [{x: (size.x.min - 1), y: y},{x: (size.x.max + 1), y: y}];
            //find intersections with all polygon edges
            for (let i = 0; i < edges.length; i++) {
              points = this.findEdgeIntersection(line, edges[i]);
              //if edge doesn't lie inside line
              if (points && (points.length === 1)) {
                 interPoints.push(points[0]);      
              }
            }
            interPoints = this.sortPoints(interPoints);
            //find two correct interpoints
            for (let i = 0; i < interPoints.length - 1; i++) {
              if (interPoints[i].t !== interPoints[i+1].t) {
                //enable exit from loop and calculate point coordinates
                pointsOK = true;
                point = {x: ((interPoints[i].x + interPoints[i+1].x) / 2), y: y};
              }
            }
            //all points are incorrect, need to change line parameters
            y = y + dy;
            if (((y > size.y.max) || (y < size.y.min)) && (pointsOK === false)) {
              pointsOK = true;
              point = undefined;
            }
          }
          return point;
        },

        getSize:function(polygon) {
          let size = {
            x: {
              min: polygon[0].x,
              max: polygon[0].x
            },
            y: {
              min: polygon[0].y,
              max: polygon[0].y
            }
          };
          for (let i = 1; i < polygon.length; i++) {
            if (polygon[i].x < size.x.min) size.x.min = polygon[i].x;
            if (polygon[i].x > size.x.max) size.x.max = polygon[i].x;
            if (polygon[i].y < size.y.min) size.y.min = polygon[i].y;
            if (polygon[i].y > size.y.max) size.y.max = polygon[i].y;
          }
          return size;
        },

        findPointInsidePolygon:function(point, polygon) {
          let cross = 0;
          let edges = this.getEdges(polygon);
          let classify;
          let org, dest;
          for (let i = 0; i < edges.length; i++) {
            [org, dest] = edges[i];
            classify = this.classifyPoint(point, [org, dest]);
            if (  (
                    (classify.loc === "RIGHT") &&
                    (org.y < point.y) &&
                    (dest.y >= point.y)
                  ) ||
                  (
                    (classify.loc === "LEFT") &&
                    (org.y >= point.y) &&
                    (dest.y < point.y)
                  )
                ) {
              cross++;    
            }
            if (classify.loc === "BETWEEN") return false;
          }
          if (cross % 2) {
            return true;
          } else {
            return false;
          }
        },

        getMidpoints:function(edges) {
          let midpoints = [];
          let x, y;
          for (let i = 0; i < edges.length; i++) {
            x = (edges[i][0].x + edges[i][1].x) / 2;
            y = (edges[i][0].y + edges[i][1].y) / 2;
            midpoints.push({x: x, y: y}); 
          }
          return midpoints;
        },
          
        log:function(obj) {
          console.log(JSON.stringify(obj));
        },
        
        sortPoints:function(points) {
            points = points.splice(0);
            var p0 = {};
            p0.y = Math.min.apply(null, points.map(p=>p.y));
            p0.x = Math.max.apply(null, points.filter(p=>p.y == p0.y).map(p=>p.x));
            points.sort((a,b)=>this.angleCompare(p0, a, b));
            return points;
        },
        angleCompare:function(p0, a, b) {
                var left = this.isLeft(p0, a, b);
                if (left == 0) return this.distCompare(p0, a, b);
                return left;
        },
        isLeft:function (p0, a, b) {
            return (a.x-p0.x)*(b.y-p0.y) - (b.x-p0.x)*(a.y-p0.y);
        },
        distCompare:function(p0, a, b) {
                var distA = (p0.x-a.x)*(p0.x-a.x) + (p0.y-a.y)*(p0.y-a.y);
                var distB = (p0.x-b.x)*(p0.x-b.x) + (p0.y-b.y)*(p0.y-b.y);
                return distA - distB;
        }
        
    });

	const Direction = {
		RIGHT : 'rightside',
		LEFT : 'leftside',
		UP : 'topside',
		DOWN : 'bottomside'
		
	}  
	
	canvasApp.selectionHelper = new Object({
		left:0,
		top:0,
		fill:"#ffffff",
		status:"",
		angle:0,
		booth_keys:"",
		lastleft:0,
		lasttop:0,
		lastMoveObject:null,
		clearProps:function(){
			this.left=0;
			this.top=0;
			this.fill="#ffffff";
			this.status="";
			this.angle=0;
			this.booth_keys="";
		},
		findNewPos:function(distX, distY, target, obj) {
	  // See whether to focus on X or Y axis
		  if(Math.abs(distX) > Math.abs(distY)) {
			  if (distX > 0) {
				  target.setLeft(obj.getLeft() - target.getWidth());
			  } else {
				  target.setLeft(obj.getLeft() + obj.getWidth());
			  }
		  } else {
			  if (distY > 0) {
				  target.setTop(obj.getTop() - target.getHeight());
			  } else {
				  target.setTop(obj.getTop() + obj.getHeight());
			  }
		  }
	  },
	  intersectMove:function(obj,top,right,direction){
		  if (top==0){
			  return false;
		  }
			  obj.setLeft(right);
				obj.setTop(top);
				obj.setCoords();
				var statusCollision=true;
				canvasApp.selectionHelper.lastMoveObject=obj;
				let overlap = false// canvasApp.safetyHelper.checkOverLap(direction); duc
				canvasApp.selectionHelper.lastMoveObject.setCoords();
				while( overlap[0] !=0 && overlap[1] !=0  ){
					
					obj.setLeft(overlap[0]);
					obj.setTop(overlap[1]);
					
					canvasApp.selectionHelper.lastMoveObject=obj;
					canvasApp.selectionHelper.lastMoveObject.setCoords();
				//    overlap = canvasApp.safetyHelper.checkOverLap(direction);
				
				}
				
				
	  },
	  tryLeftTop:function(myMap,tryLeft,tryTop){
	  
			  for(let i=0; i<myMap.length; i++){
					  
						  if (myMap[i].left==tryLeft && 
								  myMap[i].top==tryTop)
						  {
							  
							  return myMap[i];
							  
						  }
				  }
						
		return true;
	  
	  },
	  checkPoint:function(lobj,x,y){
			let objects= Object.keys(canvasObjects[1]);
			for (let i = 0; i < objects.length; ++i) {
				var key=objects[i];
							 var obj = canvasObjects[1][key]["group"];
								 if (obj.get('booth_number') != lobj.get('booth_number') 
								 && obj.get('left')==x && obj.get('top')==y){
									 var returnObj=obj;
								  break;      			
								}
			}
	   
		   return returnObj;
		  
	  },
		intersects:function(obj,targ,statusCollision){
			
					if (canvasApp.generalHelper.done==true){
						return false;	
					}
				
					if (targ.hotspot==true || obj.hotspot==true){
						return false;
					}
				
					if (snapToGrid==false){
							return false;
					}
					if (targ.selectable==false){
							return false;	
					}
				
				
				let oRepoData=canvasApp.generalHelper.boothOverlap(obj,targ);
				
				let whichDirection = oRepoData[4];
				let finalTarget =null;			
				let targetTop =  targ.get('top');
				let targetLeft =  targ.get('left');
				let incrementTop = obj.get('height');
				let incrementLeft = obj.get('width');
				let newLeft = targetLeft;
				let newTop = targetTop;
				let total_move =0;
				if (	(targ.get('left') == obj.get('left')) &&
						(targ.get('top') == obj.get('top'))	
					){
				
					obj.set('left',obj.get('lastLeft'));
					obj.set('top',obj.get('lastTop'));
  
	
					canvasApp.generalHelper.locked=false;
					canvasApp.generalHelper.done=true;
				
			  
				  return;
					 
					
				}
				if (targ.get('width')>obj.get('width')){
					while(newLeft<
							(targ.get('left')+targ.get('width')+incrementLeft))
							{
								if (obj.get('left')>newLeft){
									targetLeft=newLeft;				
								}
								newLeft=newLeft+incrementLeft;
				
							} 
				}
				
				 if (targ.get('height')>obj.get('height')){
					while(newTop<
							(targ.get('top')+targ.get('height')+incrementTop))
							{
								if (obj.get('top')>newTop){
									targetTop=newTop;				
								}
								newTop=newTop+incrementTop;
							} 
				}
				if (whichDirection.top>0){
					targetTop = targetTop - obj.get('height');
				}
				if (whichDirection.bot>0){
					targetTop = targetTop + targ.get('height');
				}
				if (whichDirection.left>0){
					targetLeft = targetLeft - obj.get('width');
				}
				if (whichDirection.right>0){
					targetLeft = targetLeft + obj.get('width');
				}
				
				if (Math.abs(targetLeft -obj.get('lastLeft'))> (obj.get('width')*2) ){
					targetLeft = obj.get('lastLeft');
				}
				if (Math.abs(targetTop -obj.get('lastTop'))> (obj.get('top')*2) ){
					targetTop = obj.get('lastTop');
				}
				
				obj.set('left',targetLeft);
				obj.set('top',targetTop);
				
			   obj.setCoords();
				canvasApp.helperCanvas.renderAll();
				
				finalTarget=this.checkPoint(obj,targetLeft,targetTop);
				if (finalTarget != null){
					
					if (whichDirection.right>0){
						obj.set('left',targetLeft+1);
							
					}
					if (whichDirection.left>0){
						obj.set('left',targetLeft-1);
							
					}
					if (whichDirection.bot>0){
						obj.set('top',targetTop+1);
							
					}
					if (whichDirection.top>0){
						obj.set('top',targetTop-1);
							
					}
					obj.setCoords();
					canvasApp.helperCanvas.renderAll();
				
				}
	
				canvasApp.generalHelper.locked=false;
				canvasApp.generalHelper.done=true;
				
			  
			  return;
					
   
	},
		selected:function(bShowError){
				//   if (canvasApp.uHelper.panMode==true){
					  
				// 	  canvasApp.uHelper.alertBox(" Unlock canvasApp.helperCanvas first","Error",'error');
					  
				// 	  return false;
				//   }
				if(!canvasApp.helperCanvas.getActiveObject()){
						if (typeof bShowError === 'undefined' || bShowError==true){
						  
						//   canvasApp.uHelper.alertBox(" Select something first","Error",'error');
						  
					  }
					  return false;
				  }
				  
				  return true;
	 
	   },
	   getImage:function(obj){
	   
					   if ( obj.type.toUpperCase().includes('IMAGE') == false){
								return obj;
					   }
					   if (typeof obj._objects !=='undefined'){
									   obj._objects.forEach(function(o){
										 if ( o.type.toUpperCase().includes('IMAGE') == false){
										   return o;
									   
									   }
								   });
								   
				   }
		  
	   },
	   getProps:function(obj){
		   
				   if (typeof obj.get('status') !=='undefined'){
							this.status = obj.get('status');
					 }
									
					  if ( obj.type.toUpperCase().includes('TEXT') == false){
									if (typeof obj.get('fill') !=='undefined'){
									this.fill = obj.get('fill');
								}
					   }
						if (typeof obj.get('id') !=='undefined' && obj.get('id').substr(0,3) !='tb_'){
								if (this.booth_keys.indexOf(obj.get('id')) ==-1){
										this.booth_keys = this.booth_keys + " " + obj.get('id');
								}
						}
						
						if (typeof obj._objects !=='undefined'){
									   obj._objects.forEach(function(o){
										if (typeof o.get('status') !=='undefined'){
											this.status = o.get('status');
										}
										 if ( obj.type.toUpperCase().includes('TEXT') == false){
												if (typeof o.get('fill') !=='undefined'){
												this.fill = o.get('fill');
											}
										}
										if (typeof o.get('angle') !=='undefined'){
											this.angle = o.get('angle');
										}
										
										if (typeof o.get('id') !=='undefined' && o.get('id').substr(0,3) !='tb_' ){
											if (this.booth_keys.indexOf(o.get('id')) ==-1){
												this.booth_keys = this.booth_keys + " " + o.get('id');
											}
										}	
									});
						}
			   
	
	   },
	   selection:function(selectedCanvas){
		   if (typeof selectedCanvas ==='undefined'){
			   selectedCanvas=canvasApp.helperCanvas;
		   }
		   let objselected =selectedCanvas.getActiveObject();
		   this.left=objselected.get('left');
		   this.top=objselected.get('top');
	   
				   
		   
		   return   objselected;
	   },
	   getObjects:function(selectedCanvas){
		   let objSelected = this.selection(selectedCanvas);
		   return objSelected.getObjects();
		   
	   },
	   create:function(){
		   canvasApp.helperCanvas.discardActiveObject();
		   canvasApp.helperCanvas.setActiveObject(canvasApp.helperCanvas.item(canvasApp.helperCanvas.getObjects().length-1));
		  canvasApp.helperCanvas.requestRenderAll();
		   
	   },
	   getPoints:function(){
			 let points = undefined;
				  
				  
				  if (typeof canvasApp.helperCanvas.getActiveObject()._objects !=='undefined'){
					  
							  canvasApp.helperCanvas.getActiveObject()._objects.forEach(function (o) {
							  
								  if (typeof o.points !== 'undefined'){
										  points = o.points;
								  }	
						  
						  });
				  }
				  
		   
		   
		   return points;
	   },
	   verify:function(aItemsNotAllowed,aTypesAllowed,whichFunction){
		   const objects = this.getObjects();
		   let gObjects=[];
		   let allowed = true;
					for (let i=0;i<objects.length;i++){
					   for (let iItem=0;iItem<aItemsNotAllowed.length;iItem++){	
							if (objects[i].get(aItemsNotAllowed[iItem])===true || 
							(typeof objects[i].get(aItemsNotAllowed[iItem]) !== 'undefined' && 
							objects[i].get(aItemsNotAllowed[iItem]).length >0 
							&& objects[i].get(aItemsNotAllowed[iItem]) !==false)){
								  allowed=false;
						   }
					   }
					   
					   for (let iType=0;iType<aTypesAllowed.length;iType++){
							if (objects[i].get('type')==aTypesAllowed[iType]){
							   gObjects.push(objects[i]);		
						   }
					   }
				   }
				   if (allowed==false || gObjects.length==0){
					   
					   switch(whichFunction)
					   {
						   case "copy":
							   
							//    canvasApp.uHelper.alertBox(' Items selected cannot be copied',"Error",'error');
							   
							   break;
							case "price":
							   
							//    canvasApp.uHelper.alertBox(' Items selected cannot be priced',"Error",'error');
							   
							   break;
					  }
					   return [];
				   }
				   
				   return gObjects;
	   
	   } 	
		
	});  
   